/** @jsx jsx */
import { css, jsx, Global } from '@emotion/react';
import { Component } from 'react';
import { AppState } from '../../app.state';
import { Alert, Switch, Modal, message } from 'antd';
import { getFWErrorProps } from '../../_shared/fw-error-modal';
import { withRouter, RouteComponentProps } from 'react-router';
import FormTitle from '../../_shared/form-title';
import SharedStyles from '../../_shared/styles';
import Link from '../../_shared/link';
import styles, { global } from './equipment-details.styles';
import {
  getEquipment,
  getEquipmentRecord,
  createOrUpdateEquipment,
} from '../../_shared/services/manage-equipment.service';
import {
  _Equipment,
  EQ_TYPE,
  Equipment,
  EquipmentRecord,
  ETYPES,
} from '../../_shared/interfaces/equipment';
import { EquipmentStatus, MaintStatus } from '../../_shared/interfaces/equipmentStatus';
import { Sidebar } from './sidebar.component';
import InfoRow, { ICol } from '../../_shared/info-row';
import _Icon from '../../_shared/icon';
import colors from '../../_shared/colors';
import { renderLabel } from '../../utils/mixins';
import { getLocation } from '../../_shared/services/manage-locations.service';
import { getOrg } from '../../_shared/services/manage-orgs.service';
import { Org } from '../../_shared/interfaces/org';
import { Location } from '../../_shared/interfaces/location';
import moment from 'moment';
import { TableList } from '../../_shared/table-list';
import { _Message } from '../../_shared/interfaces/message';
import {
  Service,
  _Service,
  ServiceSerial,
} from '../../_shared/interfaces/service';
import { _Publish } from '../../_shared/interfaces/publish';
import { Model, _Model } from '../../_shared/interfaces/model';
import { take, get, set, flatten, size, first, orderBy, keyBy, sortBy, last } from 'lodash';
import {
  canClearAlert,
  defaultDateFormat,
  errorDef,
  getDeviceStatusFromEquip,
  findModel,
  getTimeForPubAlert,
  userHasRole,
  getEquipMaint,
  convertDZNowToJSNow,
  getEquipConfig,
  guid,
  isPB,
  isDentalOrgUser,
  isDentalOrgAdmin,
  getTriggeredMaint,
  getAllDeviceIds,
  parseServiceByDate,
  TG_ROLES,
  generateTGDeviceCMD,
  getEquipmentType,
  deDupeServices,
  isHandpiece,
  getDebugStatusHandpiece,
  handpieceIsDueForService,
  wait,
  isChair,
  getEquipmentModel,
  getEqType,
  getSterilizerFlagTextFromArray,
  getServiceType,
  getRelevantAlertMap,
  isDiagAlert,
  isSmartChair,
  isMuon,
  getMuonConnection,
  sendNativeEvent,
} from '../../utils';
import { isGuestUser } from '../../authentication/authentication.actions';
import { HandpieceProfileUsageTable } from './handpieceProfileUsageTable.component';
import { sendDeviceCommand } from '../../_shared/services/manage-schedule.service';
import { ModalEvent } from '../../_shared/modal-event';
import { Button } from '../../_shared/button';
import { Sensor } from '../../_shared/interfaces/sensor';
import { ModalChart } from '../../_shared/modal-chart';
import { serviceType } from '../../_shared/lib/services';
import { getService } from '../../_shared/services/manage-services.service';
import ModelImage from '../../_shared/model-image';
import { getHistory } from '../../_shared/services/device-history.service';
import { MapOpts } from '../dashboard.actions';
import { getAlert, getMessage } from '../../utils/publish';
import { alertOf, kindOf, occurredAt, productOf } from '../../_shared/lib/device-events';
import {
  eventTime,
  newestFirst,
  sessionsEndedOn,
  statisticsWhen,
} from '../../utils/statistics';
import { getTandemGroups } from '../../_shared/services/manage-tandem-groups.service';
import {
  TandemGroup,
  _TandemGroup,
} from '../../_shared/interfaces/tandemGroup';
import AddEquipToTGModal from './add-to-tgroup-modal.component';
import { SelectValue } from 'antd/lib/select';
import {
  generateInfoRows,
  getRightTime,
  timeText,
  sensorColumnBuilder
} from './equipment-details-columns';
import { Publish } from '../../_shared/interfaces/publishData';
import { trackEvent, } from '../../_shared/services/analytics.service';
import eventTypes from '../../_shared/interfaces/api/eventTypes';
import { createPublish } from '../../_shared/services/publish.service';
import { AIcon as Icon } from '../../_shared/icon';
import { WithAppConfig, AppConfig } from '../../_shared/hooks/useAppConfig';
import { _size } from '../../utils/awaitAll';
import { ColumnProps } from 'antd/lib/table';
import { EquipPusherComponent } from '../../_shared/EquipPusher';
import { GlowingDot } from '../../_shared/glowing-dot';
import { Column, Row } from '../../_shared/row';

interface IProps extends RouteComponentProps {
  sState: AppState;
  // tslint:disable-next-line:no-any
  addToMap: (pubs: Publish[], opts?: MapOpts) => void;
  setLastEquipment: (id?: string) => void;
  waitForNewStatistic: (eq: Equipment) => Promise<unknown>;
  waitForNewConfig: (eq: Equipment) => Promise<unknown>;
  app?: AppConfig;
}

interface IState {
  loading: boolean;
  isLoading: boolean;
  equipment: Equipment;
  latestEquipmentPublishData?: EquipmentStatus;
  location?: Location;
  serviceOrg?: Org;
  dentalOrg?: Org;
  sensorsExpanded?: boolean;
  showAllMessages: boolean;
  // AER-1739: Diagnostic Alerts renders through the same renderMessages() as
  // Active Alerts but has to own its "Show Alert History" independently, so it
  // carries its own copy of the three view flags rather than sharing them.
  showAllDiagMessages: boolean;
  showAllHistory: boolean;
  showAllReminders: boolean;
  serviceHistory: Service[];
  model?: Model;
  modalVisible: boolean;
  modalChart?: {
    visible: boolean;
    chosenSensor: string;
  };
  // tslint:disable-next-line:no-any
  selectedPublish?: Publish;
  loadingSensor: boolean;
  sendingCommand: boolean;
  alertsLoading: boolean;
  expandAlerts: boolean;
  expandMaint: boolean;
  expandService: boolean;
  // AER-1591: track whether the user has manually toggled each mobile
  // collapsible section. Until they do, the section's expanded state is
  // derived from whether the underlying data is empty (collapsed) or
  // populated (expanded) per Ted's spec.
  alertsToggled: boolean;
  // AER-1739: mobile collapse state for Diagnostic Alerts. Separate from
  // alertsToggled/expandAlerts so collapsing one section doesn't collapse the
  // other.
  expandDiagAlerts: boolean;
  diagAlertsToggled: boolean;
  maintToggled: boolean;
  serviceToggled: boolean;
  tandemGroup: TandemGroup | undefined;
  tandemGroups: TandemGroup[] | undefined;
  availableTGroups: TandemGroup[] | undefined;
  addEquipToTGModalVisible: boolean;
  sensorInfo: ISensorInfo;
  deviceStatus: string;
  maintSks: string;
  totalSessionCount?: number;
}

interface IServiceReminder {
  name: string;
  hours: { text: string; color: string };
  lastServiced: string;
}

export interface ISensorInfo {
  [key: string]: string | number;
}

export class _EquipmentDetailsComponent extends EquipPusherComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    const equipment = this.getEquipment();

    this.state = {
      loading: false,
      isLoading: false,
      // DEN-838: handpieces start collapsed.
      // AER-1591: on mobile (phone-break), all equipment types start
      // collapsed — only the Performance section is shown by default with a
      // "See More Sensor Details" toggle.
      sensorsExpanded: !isHandpiece(equipment) && !isPB(props.sState),
      equipment,
      location: undefined,
      serviceOrg: undefined,
      dentalOrg: undefined,
      showAllMessages: false,
      showAllDiagMessages: false,
      showAllHistory: false,
      serviceHistory: [],
      showAllReminders: false,
      model: undefined,
      modalVisible: false,
      selectedPublish: undefined,
      activeAlerts: [],
      publishes: [],
      sensor: undefined,
      sensorInstant: undefined,
      loadingSensor: false,
      config: undefined,
      sendingCommand: false,
      alertsLoading: false,
      // AER-1591: default expanded; render time derives the *effective*
      // state from data presence (empty → collapsed) until the user
      // manually toggles, at which point the manual value wins.
      expandAlerts: true,
      expandDiagAlerts: true,
      expandMaint: true,
      expandService: true,
      alertsToggled: false,
      diagAlertsToggled: false,
      maintToggled: false,
      serviceToggled: false,
      tandemGroup: undefined,
      tandemGroups: [],
      availableTGroups: [],
      addEquipToTGModalVisible: false,
      maint: undefined,
      sensorInfo: {},
      handpiecePresetsLocked: false,
      deviceStatus: equipment.deviceStatus,
      maintSks: '',
    } as IState;
  }

  getEquipment = (): Equipment => {
    const {
      sState: { dash },
    } = this.props;
    const { state } = this.props.history.location;

    if (this.state && this.state.equipment) {
      const equipment = get(dash, 'equipment', []).find(
        (eq: Equipment) => eq.sk === this.state.equipment.sk
      );
      return new _Equipment({ ...this.state.equipment, ...(equipment || {}) });
    } else if (state && (state as any).equipment) {
      const equipment = get(dash, 'equipment', []).find(
        eq => eq.sk === (state as any).equipment.sk
      );
      return new _Equipment(equipment);
    } else if (dash.equipment) {
      return new _Equipment(dash.equipment[0]);
    } else {
      return new _Equipment();
    }
  };
  updateEquipment = async () => {
    const { sState } = this.props;
    const me: any = get(sState, 'auth.user');
    const updatedEquipment = this.getEquipment();
    set(updatedEquipment, 'updatedAt', moment().toISOString());
    set(updatedEquipment, 'updatedBy', me.userId);
    await createOrUpdateEquipment(this.getEquipment());
  };
  trackEvent = (event = '', data = {}) => {
    trackEvent(event, { ...data, equipment: this.getEquipment() });
  };
  retrieveLatestSensor = async (refreshData = true) => {
    const e = this.getEquipment();
    var { deviceStatus } = this.state;

    if (!e.deviceId) {
      return console.error('No device ID');
    }

    const failed = (err: Error, broadcastError?: boolean) => {
      console.error(err);
      if (broadcastError) {
        message.error(
          `Failed to retrieve latest sensor information. Error: ${err.message}`
        );
      }
      this.setState({
        loadingSensor: false,
      });
    };

    try {
      this.setState({ loadingSensor: true });

      const eType = getEqType(e);
      const dontSend = [ETYPES.chair, ETYPES.sterilizer].includes(eType);

      // AER-1608: track whether any sendDeviceCommand call failed. Previously
      // the per-call `.catch` blocks only updated local `deviceStatus`, then
      // the function fell through to `await waitForNewStatistic(e)` — which
      // blocked the spinner for the full 30s timeout even though we already
      // knew comms had failed. We also never re-fetched the equipment record,
      // so the backend-side `lastFailedComm` write (set by
      // `/schedule/sendDeviceCommand` on rejection) was invisible to the
      // client and `getDeviceStatusFromEquip` couldn't surface the OFFLINE
      // banner. Collect all the sendDeviceCommand promises in a single array
      // and check afterward — if any rejected, skip the long Pusher wait,
      // refresh equipment, and resolve the spinner immediately.
      const cmdPromises: Promise<unknown>[] = [];
      let anyCmdFailed = false;
      const onCmdFail = (label: string) => (err: Error) => {
        anyCmdFailed = true;
        deviceStatus = 'off';
        this.setState({ deviceStatus });
        console.error(`${label} failed`, err && err.message);
      };

      if (isHandpiece(e)) {
        // DEN-664 only send these device commands for HP on details page
        cmdPromises.push(sendDeviceCommand(
          e.deviceId,
          {
            arg: '{"cmd":"get_cfg", "cfg": {"config"}}',
          },
          { showErrorToast: true },
          isHandpiece(e)
        ).catch(onCmdFail('hp get_cfg config')));

        cmdPromises.push(sendDeviceCommand(
          e.deviceId,
          {
            arg: '{"cmd":"sensor_instant", "interval": 1, "duration": 1}',
          },
          { showErrorToast: true },
          isHandpiece(e)
        ).catch(onCmdFail('hp sensor_instant')));

        cmdPromises.push(sendDeviceCommand(
          e.deviceId,
          {
            arg: `{"cmd":"get_cfg", "cfg": {"config":{"dental_school"}}}`,
          },
          { showErrorToast: true },
          true
          // AER-1608: dental_school config is a soft probe — don't mark the
          // whole interaction as failed if it errors. Some HPs simply don't
          // implement it. Use `.catch(() => 0)` rather than `onCmdFail`.
        ).catch(() => 0));
      } else {
        const isAerasOne = eType.includes('aerasone');
        if (!dontSend && !isAerasOne) {
          cmdPromises.push(sendDeviceCommand(
            e.deviceId,
            {
              arg: 'get_runtimes',
            },
            { showErrorToast: true },
            isHandpiece(e)
          ).catch(onCmdFail('get_runtimes')));
        }

        if (isAerasOne) {
          cmdPromises.push(sendDeviceCommand(
            e.deviceId,
            { cmd: 'get_config' },
            { showErrorToast: true }
          ).catch(onCmdFail('aerasone get_config')));
        }

        if (eType !== ETYPES.sterilizer) {
          //might remove this before the demo if get_data gets setup
          cmdPromises.push(sendDeviceCommand(
            e.deviceId,
            {
              arg: isAerasOne ? { cmd: 'get_data' } : 'get_data',
            },
            { showErrorToast: true },
            isHandpiece(e)
          ).catch(onCmdFail('get_data')));
        }
      }

      // AER-1608: wait for all device commands to settle BEFORE polling
      // `waitForNewStatistic`. Previously the commands fired in parallel
      // (their promises were dangling) and we went straight to the
      // 30-second redux poll — so a fast failure (e.g. Particle says the
      // device is offline) didn't short-circuit. Settling here lets us
      // check `anyCmdFailed` and bail to the offline branch.
      await Promise.all(cmdPromises);

      // AER-1608: if comms failed, refresh equipment from the backend so we
      // pick up the freshly-written `lastFailedComm` field — that's what
      // `getDeviceStatusFromEquip` keys the OFFLINE banner on. Then clear
      // the spinner immediately rather than blocking on a publish that's
      // never going to arrive.
      if (anyCmdFailed) {
        await this.retrieveEquipment(false);
        this.setState({ loadingSensor: false });
        return;
      }

      // AER-1589: chairs/sterilizers were excluded from `dontSend` for the
      // `get_runtimes` command above (chairs respond to `get_data` instead),
      // but the same `dontSend` flag was also gating `waitForNewStatistic`
      // and `getDetailedData` below. Result: on the registration → ED deep
      // link the chair would render with null sensor values until the user
      // manually tapped Get Latest Data (Danielle's IMG_2840). For chairs
      // we still need to wait for the publish that comes back from get_data
      // and then re-pull history. Race against a short timeout so a
      // momentarily-offline device doesn't pin the spinner for 30s — if
      // the publish lands later it will flow through Pusher → addToMap.
      // Sterilizers are still excluded — they don't get `get_data` (see
      // the `eType !== ETYPES.sterilizer` guard above) so there's nothing
      // to wait for.
      const sentGetData = !isHandpiece(e) && eType !== ETYPES.sterilizer;
      if (!dontSend) {
        await this.props.waitForNewStatistic(e);
      } else if (sentGetData) {
        await Promise.race([
          this.props.waitForNewStatistic(e).catch(err => {
            console.warn('waitForNewStatistic timed out', (err as Error).message);
          }),
          wait(5000),
        ]);
      }

      // AER-1589: always refresh detailed data on the chair mount path so
      // the sensor row hydrates from the publish that landed during the
      // wait above. Previously this was gated on `refreshData` (only the
      // manual Get Latest Data button), which is why the QR-scan deep-link
      // landed on a screen with null sensors.
      const shouldRefreshDetailed = refreshData || sentGetData;
      shouldRefreshDetailed && (await this.getDetailedData());

      if (refreshData) {
        this.trackEvent(eventTypes.eq_request_data);
      }

      this.setState({
        loadingSensor: false,
      });
    } catch (err) {
      await this.retrieveEquipment();
      failed(err);
    }
  };

  getDeviceStatusText = (e?: Equipment) => {
    if (!e) e = this.getEquipment();
    const deviceState = getDeviceStatusFromEquip(e);
    const useInUseLabel = isChair(e) || isHandpiece(e);

    return deviceState.on
      ? useInUseLabel ? 'In Use' : 'Online'
      : deviceState.standby
        ? useInUseLabel ? 'Idle' : 'Standby'
        : 'Offline';
  };

  renderStatusSwitch = (e: Equipment, eqType: any) => {
    const useGlowingDot = [ETYPES.aerasone_compressor, ETYPES.aerasone_vacuum].includes(eqType) || isChair(e) || isHandpiece(e);

    if (useGlowingDot) {
      const deviceState = getDeviceStatusFromEquip(e);

      const color = deviceState.on
        ? colors.statusOn
        : deviceState.standby
          ? colors.statusStandby
          : colors.statusOff;

      return <GlowingDot color={color} />
    }

    return (
      <Switch
        onChange={this.toggleChange}
        checked={e.deviceStatus === 'on'}
        disabled={isGuestUser(this.props.sState)}
      />
    )
  }

  retrieveEquipment = async (showLoading = true) => {
    const e = this.getEquipment();
    const { sState } = this.props;

    const model = findModel(e, sState);

    this.setState({
      isLoading: true,
      loading: showLoading,
      sendingCommand: showLoading,
      model,
    });

    try {
      const equipment = await getEquipmentRecord(e.deviceId, true);
      const equipType = getEquipmentType(
        equipment.equipmentSN as string,
        equipment.modelId as string
      );
      const allEquipment = get(sState, 'dash.equipment', []) as Equipment[];
      const ids = getAllDeviceIds(equipment);
      const location = equipment.locationId
        ? await getLocation(equipment.locationId)
        : undefined;

      const tandemGroups = e.tandemGroupId
        ? await getTandemGroups({ id: { eq: e.tandemGroupId } })
        : e.locationId
          ? await getTandemGroups({ locationId: { eq: e.locationId } })
          : undefined;
      const tandemGroup =
        equipment.tandemGroupId && tandemGroups
          ? tandemGroups.find(tg => {
            return tg.id === equipment.tandemGroupId;
          })
          : undefined;
      const availableTGroups = tandemGroups
        ? tandemGroups.filter(tg => {
          const equipForTGroup = allEquipment.filter(
            equip => equip.tandemGroupId === tg.id
          );
          return (
            equipForTGroup.length &&
            equipForTGroup.length < 4 &&
            tg.equipType === equipType &&
            tg.locationId === equipment.locationId
          );
        })
        : [];
      const serviceOrg = equipment.serviceOrgId
        ? await getOrg(equipment.serviceOrgId)
        : undefined;

      const dentalOrg = e.dentalOrgId ? await getOrg(e.dentalOrgId) : undefined;

      const serviceHistorys = await Promise.all(
        ids.map(async id =>
          parseServiceByDate(await getService(id.id), id.replaceDate)
        )
      );

      const hasServices = (f: {}) => {
        const services = get(f, 'services', []).filter(getServiceType);
        return !!size(services);
      };

      if (isHandpiece(equipment) && equipment.deviceId) {
        sendDeviceCommand(
          equipment.deviceId,
          {
            arg: '{"cmd":"get_cfg", "cfg": {"revs": {}}}',
          },
          { showErrorToast: true },
          true
        ).catch(() => { });
      }

      const flattenedServices = flatten(serviceHistorys).filter(f =>
        hasServices(f)
      );

      this.setState({
        isLoading: false,
        loading: showLoading ? false : this.state.loading,
        sendingCommand: showLoading ? false : this.state.sendingCommand,
        equipment,
        location,
        tandemGroup,
        tandemGroups,
        serviceOrg,
        dentalOrg,
        serviceHistory: isHandpiece(e)
          ? flattenedServices
          : deDupeServices(flattenedServices),
        availableTGroups,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        loading: false,
        isLoading: false,
        loadingSensor: false,
        sendingCommand: false,
        equipment: new _Equipment(e),
      });
    }
  };
  //@ts-ignore
  onEvent = async event => {
    if (get(event, 'event') == 'spark/device/diagnostics/update') {
      const eq = this.getEquipment();
      const equipment = await getEquipmentRecord(eq.deviceId, true);
      this.setState({ equipment })
    }

    // AER-1589 (re-failed 2026-05-08): sensor-publish events that land via
    // Pusher AFTER the mount-time getDetailedData resolved were not being
    // reflected in the rendered Chair Sensors / Performance row, because
    // `latestEquipmentPublishData` is only written from inside
    // `getDetailedData` (line ~579). On the QR-scan deep-link path the
    // device's get_data response routinely arrives 5–15s after ED has
    // already mounted and called getDetailedData — Danielle's Friday
    // recording is a textbook case (data fetched, screen stays `--` until
    // Get Latest Data is tapped manually).
    //
    // When a sensor publish arrives on the subscribed Pusher channel (the
    // ai_/chair_/dz_/ster_sensor_* / instant / statistics families that
    // loadPusherChannel binds at line ~46), pull the fresh equipment
    // record and refresh `latestEquipmentPublishData` so the row hydrates
    // automatically. Other event families (alerts, schedule, etc.) are
    // explicitly excluded so we don't generate spurious API traffic for
    // events that don't change _status.
    const eventName = get(event, 'event', '') as string;
    const isSensorPublish =
      typeof eventName === 'string' &&
      /sensor_(instant|statistics)/.test(eventName);
    if (isSensorPublish) {
      // AER-1589 (re-failed 2026-05-15): the chair sensor row reads its values
      // from `dash.equipMap.{deviceId}.sensorStatistics` (Redux), which
      // addToMap has already populated above this handler. But getSensorInfo
      // gates on `latestEquipmentPublishData` being truthy and returns {} if
      // it's still undefined — leaving the row stuck at `--` even though the
      // data is in Redux. Set the gate immediately so the upcoming re-render
      // (triggered by addToMap's SET_MAP dispatch) renders the values from
      // Redux. Then optionally refresh _status from the backend for the
      // other fields (dz_maint, dz_config, etc.) that legitimately need it.
      if (!this.state.latestEquipmentPublishData) {
        this.setState({ latestEquipmentPublishData: {} as EquipmentStatus });
      }
      try {
        const eq = this.getEquipment();
        if (eq && eq.deviceId) {
          const fulleq = await getEquipmentRecord(eq.deviceId, true);
          const fresh = fulleq && get(fulleq, '_status');
          if (fresh) {
            this.setState({
              latestEquipmentPublishData: fresh as EquipmentStatus,
            });
          }
        }
      } catch (err) {
        console.warn('AER-1589 sensor-publish refresh failed', (err as Error).message);
      }
    }
  }
  getDetailedData = async () => {
    const eq = this.getEquipment();
    //only retrieve the alerts if we haven't done so for this piece of equipment
    this.setState({ alertsLoading: true, loadingSensor: true });
    try {
      if (eq && eq.deviceId) {
        const result = await this.loadPusherChannel(eq, { loadDetailedData: true, onEvent: this.onEvent });
        const fulleq = await getEquipmentRecord(eq.deviceId, true);

        // This used to "repair" the record's alert and maintenance status by re-posting a publish
        // from history to /publish/create whenever the two disagreed. Every re-post was stored and
        // handled as a new publish (status, notifications, partner forwarding, the Alert Events
        // report), a chair's under the store's renamed event dz_alert, a replaced device's under the
        // new device's id: on 2026-08-31..09-02 60 alert events were alerts published up to 7 months
        // earlier. Keeping status right is the server's job.
        this.calculateV8ChairValues(eq, get(result, '0.data', []) as any[]);

        this.setState({
          latestEquipmentPublishData: fulleq._status as EquipmentStatus,
        });
      }
    } catch (err) {
      console.error(err);
    }
    this.setState({ alertsLoading: false, loadingSensor: false });
  };
  
  calculateV8ChairValues = async (eq: EquipmentRecord, pubs: Publish[]) => {
    const eqType = getEqType(eq);
    if (eqType === 'chair' || eqType === 'handpiece') {
      const product = productOf(eqType, eq);
      // each once, newest first by when it happened
      const data = newestFirst(product, pubs.filter(p => kindOf(p) === 'statistics'));

      const firmwareVersion = get(data, '0.fw_version', 0) as number;
      const hasSessionData = eqType === 'chair' ? firmwareVersion >= 8
        : eqType === 'handpiece' ? firmwareVersion >= 9
        : false;

      if (hasSessionData) {
        // track days already counted, e.g. { 1_day: true, 355_day: true }
        const days = {};

        let count = 0;
        data.forEach(d => {
          // the newest row for a day carries that day's sessions_per_day. A row counts on the day
          // it covers (a daily, which arrives at the midnight after it) or ended (a session),
          // whenever it arrived: from chair firmware 30 a row can arrive days late (AERFW-79).
          // Keyed by date, not day of year, so a year ago is a different day.
          const dayval = statisticsWhen(product, d).format('YYYY-MM-DD');
          if (!get(days, dayval)) {
            set(days, dayval, true);
            count += get(d, 'data.sessions_per_day', 0);
          }
        })

        this.setState({ totalSessionCount: count });
      }

    }
  }
  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    const e = this.getEquipment();
    if (e.modelId != get(prevState, 'equipment.modelId')) {
      return this.setState({ equipment: e, model: findModel(this.state.equipment, this.props.sState), maintSks: '' })
    }

    // AER-1589: when ED is reached via a `?equipmentDetailsSN=` deep link the
    // dashboard's `dash.models` cache may not be hydrated yet at the moment
    // this component mounts (retrieveData runs in parallel). Without this the
    // `model` state stays `undefined` for the rest of the session — which
    // leaves ModelImage stuck on the Ant loading spinner (the curved-arc
    // “parenthesis” QA flagged) and generateInfoRows returns undefined so the
    // Chair Sensors / Performance row never renders. Re-run findModel as soon
    // as the matching model lands in the redux store. setState is gated on a
    // `found` lookup, so this only fires once per render cycle when the model
    // genuinely transitions from missing to present.
    if (!this.state.model && e && e.modelId) {
      const found = findModel(e, this.props.sState);
      if (found) {
        this.setState({ model: found });
      }
    }

    const oldmaint = get(this, 'state.maintSks', '');
    const newmaint = get(this.props.sState, `dash.equipMap.${e.deviceId}.maint`, []).map((s: any) => get(s, 'sk')).toString();
    if (oldmaint != newmaint) {
      //received a new maint from pusher, so need to check to see if we got any new service records
      this.setState({ maintSks: newmaint }, () => this.retrieveEquipment(false))
    }
  }
  componentDidMount = () => {
    // AER-1590: SPA does not reset scroll on route change, so tapping an item
    // from a scrolled Dashboard landed Equipment Details at the prior scroll
    // Y. Reset both the inner ContentContainer (matches the pagination pattern
    // in manage-equipment/renders) and window scroll on entry.
    const contentEl = document.getElementById('ContentContainer');
    if (contentEl) contentEl.scrollTop = 0;
    if (typeof window !== 'undefined') window.scrollTo(0, 0);

    this.trackEvent(eventTypes.eq_view);
    const { history } = this.props;
    const state = get(history, 'location.state', {});
    this.setState({ ...(state as any) }, async () => {
      const equipment = this.getEquipment();
      if (equipment && equipment.id) {
        this.props.setLastEquipment(equipment.id);
      }
      this.retrieveEquipment();

      // AER-1589 (re-failed 2026-05-08): on the QR-scan → Equipment Registration
      // → ED deep-link path, Danielle's Friday recording showed Chair Sensors
      // stuck at `--` until she manually tapped Get Latest Data. Root cause was
      // a race in the original parallel-fire pattern: `retrieveLatestSensor`
      // sent `get_data` to the device immediately, but `getDetailedData` —
      // which calls `loadPusherChannel` to subscribe to the device's publish
      // channel — was racing it on the same tick. The device's publish
      // response was therefore landing BEFORE the Pusher channel finished
      // binding, so `waitForNewStatistic`'s redux poll never saw a new SK and
      // the in-`retrieveLatestSensor` `getDetailedData` re-pull hit the API
      // before the backend had processed the publish. Net effect: the user
      // sat on a screen of `--` until they hit Get Latest Data manually,
      // which by then had a subscribed channel (from the first mount-time
      // pass) and worked end-to-end.
      //
      // Fix: `await` getDetailedData first so the Pusher binding is in place,
      // then fire retrieveLatestSensor. retrieveLatestSensor's internal
      // `await getDetailedData()` (gated on shouldRefreshDetailed for chairs)
      // then re-pulls the now-fresh _status after the device publish has
      // been ingested. HP keeps its DEN-664 carve-out (no auto get_data on
      // ED entry); smart chairs likewise — neither of those paths needs the
      // mount-time get_data and re-introducing it would generate noise.
      await this.getDetailedData();

      // DEN-664 do not load sensor data on page load for HP
      if (!isHandpiece(this.getEquipment()) && !isSmartChair(this.getEquipment())) {
        this.retrieveLatestSensor(false);
      }
    });
  };
  //NEED TO HANDLE THE UNMOUNT FROM THE EXTENDED COMPONENT
  // componentWillUnmount(): void {
  //   this.unmount();      
  // }
  // AER-1739: the Alert History view is a full-screen takeover — every sibling
  // section on Equipment Details hides behind it. Diagnostic Alerts opens the
  // same takeover off its own flag, so the sites that used to test
  // `showAllMessages` alone now ask this instead.
  isAlertHistoryOpen = () => {
    const { showAllMessages, showAllDiagMessages } = this.state;
    return showAllMessages || showAllDiagMessages;
  };
  goBack = () => {
    const { showAllHistory, showAllReminders } = this.state;
    if (this.isAlertHistoryOpen() || showAllHistory || showAllReminders) {
      return this.setState({
        showAllMessages: false,
        showAllDiagMessages: false,
        showAllHistory: false,
        showAllReminders: false,
      });
    }
    this.props.history.goBack();
  };
  goToAddUser = (orgId: string) => {
    this.props.history.replace({
      pathname: '/dashboard/addUser',
      state: { orgId: orgId, role: 2 },
    });
  };
  toggleChange = () => {
    if (userHasRole([6, 7], this.props.sState)) {
      this.renderBadAccessAlert();
      return;
    }
    const { sendingCommand } = this.state;

    let equipment = this.getEquipment();

    const isCurrentlyOn = equipment.deviceStatus === 'on';

    if (sendingCommand) {
      return message.error(
        'Currently sending a command. Please wait for the command to complete.'
      );
    }

    const submitStandyToggle = () => {
      this.setState(
        {
          sendingCommand: true,
        },
        async () => {
          try {
            await sendDeviceCommand(
              equipment.deviceId || '',
              {
                arg: isCurrentlyOn ? 'on,0' : 'on,1',
              },
              { showErrorToast: true },
              isHandpiece(equipment)
            );
            const latestConfig: any = getEquipConfig(equipment, this.props.sState);
            set(latestConfig, 'data.device_on.0', isCurrentlyOn ? false : true);
            set(latestConfig, 'data.device_on.1', moment().valueOf());
            set(latestConfig, 'fromApp', true);
            latestConfig.id = guid();
            latestConfig.published_at = new Date().toISOString();
            await createPublish(latestConfig);
            message.success(
              `Equipment has been set to ${isCurrentlyOn ? 'Standby' : 'On'}`
            );
            this.trackEvent(eventTypes.eq_toggle_status, {
              new_state: isCurrentlyOn ? 'standby' : 'on',
            });
            const newStatus = isCurrentlyOn ? 'standby' : 'on';
            equipment.deviceStatus = newStatus;
            this.setState({ sendingCommand: false, equipment, deviceStatus: newStatus });
          } catch (err) {
            message.error('Equipment status can not be adjusted at this time.');
            this.setState({
              sendingCommand: false,
            });
          }
        }
      );
    };

    this.props.app.modal.confirm({
      title: `Set Equipment to ${isCurrentlyOn ? 'Standby' : 'On'}`,
      content:
        // tslint:disable-next-line:max-line-length
        `Are you sure you want to manually set this equipment to ${isCurrentlyOn ? 'Standby' : 'On'
        }?`,
      onOk: submitStandyToggle,
      okText: isCurrentlyOn ? 'Standby' : 'On',
      onCancel: () => 0,
    });
  };
  // AER-1591: condense a Location's address (object or string) into a single
  // line for the mobile location row (Figma 491:646: location name on top,
  // address below, no DO name).
  formatLocationAddress = (loc: Location | undefined): string => {
    if (!loc) return '';
    const addr = get(loc, 'address');
    if (!addr) return '';
    if (typeof addr === 'string') return addr;
    const cityStateZip = [
      get(addr, 'city'),
      get(addr, 'state'),
      get(addr, 'zip'),
    ]
      .filter(Boolean)
      .join(', ');
    return [get(addr, 'address'), get(addr, 'address2'), cityStateZip]
      .filter(Boolean)
      .join(', ');
  };
  renderSubTitle = () => {
    const { sState } = this.props;
    const { dentalOrg, loadingSensor, location } = this.state;

    const labelStyles = `margin: 0;`;

    const isGuest = isGuestUser(sState);
    const showBtn = !isGuest && !dentalOrg && !location;
    const hasLocation = get(location, 'name');
    const eisSmart = isSmartChair(this.getEquipment());

    const ispb = isPB(sState);

    // AER-1591: on mobile, replace the DO-name + bullet + Location-name +
    // DO-address layout with a single row: location-pin icon + location name
    // (line 1) + location address (line 2). DO name is intentionally omitted
    // per Ted's spec.
    if (ispb) {
      // AER-1591: mobile location row — pin icon + 2-line text (name +
      // address). The "Get Latest Data" button moved to the actions row
      // that sits above the top card.
      const locName = hasLocation || 'No Location';
      const locAddr = this.formatLocationAddress(location);
      return (
        <div css={css(styles.mobileLocationRow)}>
          <Icon
            type="environment"
            theme="outlined"
            css={css(styles.mobileLocationIcon)}
          />
          <div css={css(styles.mobileLocationText)}>
            <div
              css={css(
                styles.mobileLocationName,
                !hasLocation && 'font-style: italic;'
              )}
            >
              {locName}
            </div>
            {!!locAddr && (
              <div css={css(styles.mobileLocationAddress)}>{locAddr}</div>
            )}
          </div>
        </div>
      );
    }

    const labels = [
      renderLabel('name', {
        obj: dentalOrg,
        styles: labelStyles + 'font-weight: bold;',
      }),
      showBtn ? (
        <Button
          title="Assign Customer"
          onClick={() => this.props.history.push('/dashboard/manageDentalOrgs')}
        />
      ) : (
        renderLabel('name', {
          obj: { name: hasLocation || 'No Location' },
          styles: labelStyles + (!hasLocation && 'font-style: italic'),
        })
      ),
    ].filter(l => l);

    const address = renderLabel('address', {
      obj: dentalOrg,
      styles: labelStyles,
    });

    return (
      <div css={css(SharedStyles.row, `align-items: start`)}>
        <div css={css(SharedStyles.column, `align-items: start`)}>
          <div
            css={css(SharedStyles.row, `font-size: 12px; margin-bottom: 10px;`)}
          >
            {labels.map((l, i) => {
              return (
                <div css={css(SharedStyles.row)} key={i}>
                  {l}
                  <span>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    {i === labels.length - 1 ? '' : '•'}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </div>
              );
            })}
          </div>
          <div css={css(`margin-bottom: 10px; font-size: 12px;`)}>
            {!!get(dentalOrg, 'address.address', '') && <div>{address}</div>}
          </div>
        </div>

        {!this.isAlertHistoryOpen() && !eisSmart && (
          <Button
            css={css(`margin-left: auto;`)}
            title="Get Latest Sensor Data"
            loading={loadingSensor}
            onClick={() => this.retrieveLatestSensor(true)}
          />
        )}
      </div>
    );
  };
  getSensorInfo = (): ISensorInfo => {
    const { sState } = this.props;
    const { latestEquipmentPublishData, equipment } = this.state;

    if (!latestEquipmentPublishData) {
      return {};
    }

    const eqType = getEqType(equipment);
    const isHp = eqType === ETYPES.handpiece;
    // how this unit's publishes are read (src/_shared/lib/device-events.ts)
    const product = productOf(eqType, equipment);

    // this is called "sensors," but it's initialized with an array
    // of everything in dash.equipMap.equipmentid.sensorStatistics, which
    // despite the name actually seems to be all the events? because i
    // see us getting alert data from it, too.
    // Each once, newest first by when it happened: a utility unit sends a day's totals when it is
    // next switched on, a chair from firmware 30 queues its statistics (AERFW-79), and Particle can
    // hand us a publish twice.
    const sensors = newestFirst(
      product,
      get(sState, `dash.equipMap.${equipment.deviceId}.sensorStatistics`, [])
    );
    const newest = <T,>(rows: T[]) => (rows[0] || {}) as T;

    // tslint:disable-next-line:no-any
    const daily = sensors.filter((s: any) => {
      if (get(s, 'data.daily')) return true;
      if (eqType === ETYPES.chair) {
        if (get(s, 'fw_version') < 10) {
          return get(s, 'data.type') === 1;
        }
        return get(s, 'data.type') === 0;
      }
      if (eqType === ETYPES.handpiece) {
        return get(s, 'data.statistics_type') === 0;
      }
      if (eqType === ETYPES.sterilizer) {
        return !s.event.includes('instant');
      }
      return false;
     //return get(s, 'data.daily');
    });
    const instants = sensors.filter(
      (s: any) => s.event === 'dz_sensor_instant'
    );
    // filters all events down to sensor stats, newest first like sensors
    const latestStats = sensors
      // tslint:disable-next-line:no-any
      .filter((s: any) => s.event === 'dz_sensor_statistics');
    const latestInstantPublish = newest(instants);
    let latestStatisticsPublish = newest(latestStats);

    const latestMaintPublish = newest(
      newestFirst(product, getEquipMaint(equipment, sState))
    );

    var latestPublish;

    if (_size(latestInstantPublish) && _size(latestStatisticsPublish)) {
      // the reading taken last, whichever reached us last
      latestPublish =
        eventTime(product, latestInstantPublish).isAfter(eventTime(product, latestStatisticsPublish))
          ? latestInstantPublish
          : latestStatisticsPublish;
    } else if (_size(latestInstantPublish)) {
      latestPublish = latestInstantPublish;
    } else if (_size(latestStatisticsPublish)) {
      latestPublish = latestStatisticsPublish;
    }

    if (!latestPublish) {
      return {};
    }

    const isLatestPublishInstant =
      get(latestPublish, 'event', '').indexOf('instant') > -1;

    // latestPublish data is either gonna be right there (if it is an instant of sensor_instant)
    // OR the data is going to be the 3rd item (2nd index) in an array (if it is an instant of sensor_statistics)
    const rawAccessor = isLatestPublishInstant ? '' : '.2';

    let cyclesTotal = 0;
    let cyclesSuccess = 0;
    if (eqType === ETYPES.sterilizer) {
      const relevant = latestStats.filter(
        //@ts-ignore
        f =>
          !get(f, 'data.daily') &&
          eventTime(product, f).isSame(moment(), 'day')
      );
      //@ts-ignore
      relevant.map(r => {
        const suc = get(r, 'data.success', false);
        cyclesTotal++;
        if (suc) {
          cyclesSuccess++;
        }
      });

      latestStatisticsPublish = latestStats.find(
        //@ts-ignore
        // tslint:disable-next-line:no-any
        (s: any) => !get(s, 'data.daily')
      ) as any;
    }

    const specialAdds = {};

    if (eqType === ETYPES.chair || eqType === ETYPES.handpiece) {
      // Add total session count to sn
      set(specialAdds, 'totalSessionCount', this.state.totalSessionCount);
      // today's sessions are the ones that ended today, once each, whenever they arrived: from
      // firmware v30 a chair can deliver a session days late, or twice (AERFW-79)
      set(specialAdds, 'currentDay', sessionsEndedOn(product, latestStats, moment()));
    }

    const sn = {
      ...specialAdds,
      ...get(latestPublish, 'data', {}),
      latestStats,
      latest: latestPublish,
      latestStat: latestStatisticsPublish,
      latestDaily: first(daily),
      latest_session_stat: latestStats.find(
        // tslint:disable-next-line:no-any
        (l: any) => get(l, 'data.type') === 1 || get(l, 'data.statistics_type') === 1
      ),
      latest_daily_stat: latestStats.find(
        // tslint:disable-next-line:no-any
        (l: any) => get(l, 'data.type') === 0 || get(l, 'data.statistics_type') === 0
      ),
      latestMaint: get(latestEquipmentPublishData, 'dz_maint'),
      latestInstant: latestInstantPublish,
      cyclesTotal,
      cyclesSuccess,
      BP: get(latestPublish, `data.BP${rawAccessor}`, null),
      PS: get(latestPublish, `data.PS${rawAccessor}`, null),
      M1T: get(latestPublish, `data.M1T${rawAccessor}`, null),
      M2T: get(latestPublish, `data.M2T${rawAccessor}`, null),
      M3T: get(latestPublish, `data.M3T${rawAccessor}`, null),
      M1P: get(latestPublish, `data.M1P${rawAccessor}`, null),
      M2P: get(latestPublish, `data.M2P${rawAccessor}`, null),
      M3P: get(latestPublish, `data.M3P${rawAccessor}`, null),
      TP: get(latestPublish, `data.TP${rawAccessor}`, null),
      TT: get(latestPublish, `data.TT${rawAccessor}`, null),
      TH: get(latestPublish, `data.TH${rawAccessor}`, null),
      AT: get(latestPublish, `data.AT${rawAccessor}`, null),
      AH: get(latestPublish, `data.AH${rawAccessor}`, null),
      VL: get(latestPublish, `data.VL${rawAccessor}`, null),
      M1R: get(latestMaintPublish, `data.motor1.1`, null),
      M2R: get(latestMaintPublish, `data.motor2.1`, null),
      M3R: get(latestMaintPublish, `data.motor3.1`, null),
      ER: get(latestMaintPublish, `data.general.1`, null),
      PDP: get(latestPublish, `data.PDP${rawAccessor}`, null),
      ALT: get(latestPublish, `data.ALT${rawAccessor}`, null),
      DE: get(latestPublish, `data.DE${rawAccessor}`, null),
      RGT: get(latestPublish, `data.RGT${rawAccessor}`, null),
      PU: get(daily, `0.data.kwh`, null),
      HDC: get(latestPublish, `data.HDC${rawAccessor}`, null),
      ODR: get(latestPublish, `data.ODR${rawAccessor}`, null),
      VE: get(latestPublish, `data.VE${rawAccessor}`, null),
      PR: get(latestMaintPublish, `data.pump.1${rawAccessor}`, null),
      WO: get(latestPublish, `data.WO${rawAccessor}`, null),
      OL: get(latestPublish, `data.OL${rawAccessor}`, null),
      WP: get(latestPublish, `data.WP${rawAccessor}`, null),
      IP: get(latestPublish, `data.IP${rawAccessor}`, null),
      PT: get(latestPublish, `data.PT${rawAccessor}`, null),
      TMP: get(
        latestPublish,
        isHp ? `data.TMP${rawAccessor}` : `data.0${rawAccessor}`,
        null
      ),
      AP: get(
        latestPublish,
        isHp ? `data.AP${rawAccessor}` : `data.2${rawAccessor}`,
        null
      ),
      TOQ: get(latestPublish, `data.3${rawAccessor}`, null),
      TOQAVG: get(latestStatisticsPublish, `data.TOQ.2`, null), //todo check
      TOQMAX: get(latestStatisticsPublish, `data.TOQ.1`, null), //todo check
      SPD: get(latestPublish, `data.4${rawAccessor}`, null),
      SPDAVG: get(latestStatisticsPublish, `data.SPD.2`, null), //todo check
      SPDMAX: get(latestStatisticsPublish, `data.SPD.1`, null), //todo check
      IA: get(
        latestPublish,
        isHp ? `data.IA${rawAccessor}` : `data.5${rawAccessor}`,
        null
      ),
      IB: get(
        latestPublish,
        isHp ? `data.IB${rawAccessor}` : `data.6${rawAccessor}`,
        null
      ),
      IC: get(
        latestPublish,
        isHp ? `data.IC${rawAccessor}` : `data.7${rawAccessor}`,
        null
      ),
      TOTI: get(
        latestPublish,
        isHp ? `data.TOTI${rawAccessor}` : `data.8${rawAccessor}`,
        null
      ),
      EMFA: get(
        latestPublish,
        isHp ? `data.EMFA${rawAccessor}` : `data.10${rawAccessor}`,
        null
      ),
      EMFB: get(
        latestPublish,
        isHp ? `data.EMFB${rawAccessor}` : `data.11${rawAccessor}`,
        null
      ),
      EMFC: get(
        latestPublish,
        isHp ? `data.EMFC${rawAccessor}` : `data.12${rawAccessor}`,
        null
      ),
      DC: get(latestPublish, `data.13${rawAccessor}`, null),
      PWR: get(latestPublish, `data.14${rawAccessor}`, null),
      VDC: get(
        latestPublish,
        isHp ? `data.VDC${rawAccessor}` : `data.14${rawAccessor}`,
        null
      ),
      AMG: get(latestInstantPublish, `data.AMG`, null),
      bars: get(latestPublish, `data.bars${rawAccessor}`, null),
      MTR: isHp
        ? get(latestPublish, `data.MTR${isLatestPublishInstant ? '' : '.0'}`, 0)
        : 0, // DEN-848 this value is a single value in when it is coming from sensor_stat publishes where we normall expect a 3 member array and pull the last one.
      // when the reading was taken (a handpiece's: when its last session ended)
      when: eventTime(product, latestPublish).toISOString(),
    };

    // console.log({ sn });

    return sn;
  };
  clickCol = (sensor: string, sensorInfo: ISensorInfo, opts = {}) => {
    const { loadingSensor } = this.state;
    if (loadingSensor) return;
    if ((sensorInfo[sensor] == null || get(opts, 'data') === null) && sensor !== 'AMG' && !get(opts, 'data')) {
      return Modal.warn({
        title: 'Data Not Available',
        content:
          //tslint:disable-next-line: max-line-length
          'Data is not currently available for this sensor.  If you feel that this is an error, call DENTALEZ tech support (866-383-4636).',
        onOk: () => 0,
      });
    }
    this.trackEvent(eventTypes.eq_sensor_history, { sensorId: sensor });
    this.setState({
      modalChart: {
        ...opts,
        visible: true,
        chosenSensor: sensor,
      },
    });
  };
  renderInfoRow1 = (row?: { title: string; columns: ICol[] }) => {
    if (!row) {
      return null;
    }

    const { sState } = this.props;
    const { loadingSensor } = this.state;
    const ispb = isPB(sState);

    return (
      <InfoRow
        isPhoneBreak={ispb}
        // AER-1591: mobile redesign — clean look (no colored background or
        // outer border), keep the per-cell vertical separator that comes for
        // free from `border-right` on `info-row col`.
        noFill={ispb}
        header={() =>
          ispb ? (
            // AER-1591: on mobile use the same `mobileSectionHeader` rule
            // ("Active Alerts" / "Maintenance Alerts" / "Service Records"
            // also use it) so the title font and indentation match across
            // every section.
            <div css={css(styles.mobileSectionHeader)}>
              <span css={css('position: relative;')}>
                {row.title}
                {loadingSensor && (
                  <Icon
                    type="loading"
                    css={css('position: absolute; right: -20px; bottom: 2px;')}
                  />
                )}
              </span>
            </div>
          ) : (
            <div
              css={css(SharedStyles.row, `font-weight: bold; padding: 5px;`)}
            >
              <div css={css('position: relative;')}>
                {row.title}
                {loadingSensor && (
                  <Icon
                    type="loading"
                    css={css('position: absolute; right: -20px; bottom: 2px;')}
                  />
                )}
              </div>
            </div>
          )
        }
        columns={row.columns}
      />
    );
  };
  renderInfoRowEx = (row?: { title: string; columns: ICol[] }, opts = {}) => {
    const { sState } = this.props;
    const { sensorsExpanded } = this.state;

    if (!row) {
      return null;
    }

    const ispb = isPB(sState);

    opts = {
      includeLink: false,
      sensorInfo: null,
      equipment: null,
      ...opts,
    };

    const sensorInfo: any = get(opts, 'sensorInfo');
    const e: any = get(opts, 'equipment');

    return (
      <div>
        <div
          css={css(SharedStyles.row, `margin-left: -4px; margin-bottom: 18px;`)}
        >
          {sensorsExpanded && <div css={css(styles.title)}>{row.title}</div>}

          {!!get(opts, 'includeLink') && (
            <div
              css={css(
                `margin-left: auto; margin-top: 15px; margin-bottom: ${sensorsExpanded ? 15 : 0
                }px;`
              )}
            >
              {sensorsExpanded && (
                <div css={css(styles.date)}>
                  {!!get(sensorInfo, 'when')
                    ? `${isHandpiece(e)
                      ? 'Data from last session on'
                      : 'Last Updated'
                    }: ${moment(sensorInfo.when).format('MMM DD h:mm a')}`
                    : ''}
                </div>
              )}

              <Link
                css={css`
                  margin-left: auto;
                `}
                onClick={() =>
                  this.setState({ sensorsExpanded: !sensorsExpanded }, () => {
                    this.state.sensorsExpanded &&
                      this.retrieveLatestSensor(true);
                  })
                }
              >
                {`See ${sensorsExpanded ? 'Less' : 'More'} Sensor Details`}
              </Link>
            </div>
          )}
        </div>

        {sensorsExpanded && (
          <InfoRow noFill={true} isPhoneBreak={ispb} columns={row.columns} />
        )}
      </div>
    );
  };
  renderBlank = (msg: string) => {
    return <p css={css(styles.blankMessage)}>{msg}</p>;
  };
  // AER-1605: determine whether a specific publish is the *active* entry for
  // its source in the given alert map. The Clear button (modal) and the Clear
  // column X button on Alert History must share this logic — historic minor
  // alerts share a `data.source` with the current active one, so a plain
  // `alertMap[source]` truthiness check incorrectly flagged every historic
  // minor alert as clearable. Compare by id when both sides have one,
  // otherwise fall back to `published_at` (always present on Publish) to
  // avoid the `undefined === undefined` trap.
  // tslint:disable-next-line:no-any
  isPublishActiveInMap = (pub: any, alertMap: any): boolean => {
    if (!pub || !alertMap) return false;
    const source = get(pub, 'data.source');
    const entry = get(alertMap, source);
    if (!entry) return false;
    const mapId = get(entry, 'id');
    const pubId = get(pub, 'id');
    if (mapId !== undefined && pubId !== undefined) {
      return mapId === pubId;
    }
    const mapPub = get(entry, 'published_at');
    const selPub = get(pub, 'published_at');
    return !!mapPub && !!selPub && mapPub === selPub;
  };
  // tslint:disable-next-line:no-any
  openModal = (row: any) => {
    const alert = row;
    this.setState({
      modalVisible: true,
      selectedPublish: alert,
    });
  };
  renderPerProfileUsage = (): JSX.Element => {
    const { isLoading, latestEquipmentPublishData } = this.state;

    const profiledata = get(
      latestEquipmentPublishData,
      'dz_profile_runtimes.data.profiles'
    );

    return (
      <div>
        <div css={css(SharedStyles.row, styles.title, 'margin-top: 10px;')}>
          {'Profile Usage'}
        </div>
        {isLoading ? (
          <Icon type="loading" />
        ) : latestEquipmentPublishData && !!profiledata ? (
          <HandpieceProfileUsageTable data={profiledata} />
        ) : (
          this.renderBlank(
            'No profile data has been received for this equipment.'
          )
        )}
        <div css={css(styles.hrMain)} />
      </div>
    );
  };
  // AER-1739: `diag` is only ever stamped on utility equipment (AER-1737
  // filters on a compressor/vacuum model type), so the Active/Diagnostic split
  // is scoped to those two types. Every other equipment type keeps the single
  // undivided alert list it has always had.
  isDiagSplitType = (eqType: string) =>
    [ETYPES.compressor, ETYPES.vacuum].indexOf(eqType) > -1;
  // Diagnostic Alerts is an internal triage tool, so the section itself is
  // restricted to DentalEZ Admin (0) and Tech (1). Note this gates *display of
  // the section* only — diagnostic alerts are withheld from Active Alerts for
  // every role, which is the whole point of moving them out.
  canSeeDiagAlerts = (eqType: string) =>
    userHasRole([0, 1], this.props.sState) && this.isDiagSplitType(eqType);
  activeAlerts: Publish[] = [];
  // AER-1739: renders Active Alerts (default) or Diagnostic Alerts
  // (`diagOnly`). The two sections are functionally identical per the ticket —
  // same columns, same rows, same clear/modal actions, same Show Alert History
  // link — so this is parameterised rather than duplicated or extracted into a
  // sub-component: the body closes over ~10 instance members (openModal,
  // isPublishActiveInMap, renderBlank, trackEvent, state.equipment...) that
  // extraction would have to thread through as props, and any drift between a
  // copy and the original is a bug by definition.
  renderMessages = (diagOnly: boolean = false) => {
    const { sState } = this.props;
    const {
      loading,
      alertsLoading,
    } = this.state;
    const e = this.getEquipment();

    const ispb = isPB(sState);
    const eqType = getEqType(e);
    const eissmart = isSmartChair(e);

    // AER-1739: bail before the smart-chair / sterilizer branches below —
    // sterilizers hand off to renderHistory(), which must never be rendered
    // twice on one screen.
    if (diagOnly && !this.canSeeDiagAlerts(eqType)) { return null }

    if (eissmart) { return null }

    if (eqType === ETYPES.sterilizer) {
      return this.renderHistory();
    }

    // AER-1739: each section drives its own Show Alert History takeover and,
    // on mobile, its own collapse state.
    const showAllMessages = diagOnly
      ? this.state.showAllDiagMessages
      : this.state.showAllMessages;
    const expandAlerts = diagOnly
      ? this.state.expandDiagAlerts
      : this.state.expandAlerts;
    const alertsToggled = diagOnly
      ? this.state.diagAlertsToggled
      : this.state.alertsToggled;
    const setShowAllMessages = (show: boolean) =>
      diagOnly
        ? this.setState({ showAllDiagMessages: show })
        : this.setState({ showAllMessages: show });

    const startDate = moment(e.installDate);
    // by when each alert happened, which can be long before it reached us, and read the way its
    // product sends it (a handpiece nests the alert in data.alert)
    const product = productOf(eqType, e);
    // tslint:disable-next-line:no-any
    const happened = (a: any) => occurredAt(product, a).at;
    const alerts = get(sState, `dash.equipMap.${e.deviceId}.alerts`, []).filter(
      // tslint:disable-next-line:no-any
      (a: any) => happened(a).isAfter(startDate)
    );
    const alertMap = { ...get(e, `_status.alertMap`, {}) as any, ...get(sState, `dash.equipMap.${e.deviceId}.alertMap`, {}) };

    let activeAlerts = [];
    for (let k in alertMap) {
      let opts = alertMap[k];
      if ((alertOf(product, opts).error || 0) > 0 && happened(opts).isAfter(startDate)) {
        activeAlerts.push(opts);
      }
    }
    activeAlerts = orderBy(activeAlerts, (a) => happened(a).valueOf(), 'desc');
    // AER-1739 LANDMINE: `this.activeAlerts` is a side-effect field that
    // render() turns into the alertMap deciding whether the event modal offers
    // "Clear Alert". It must stay the FULL union of active alerts — filtering
    // the diagnostic ones out here would silently make them unclearable. Only
    // the *display* arrays below are split. Both section renders assign the
    // same union, so it does not matter which of them runs.
    this.activeAlerts = activeAlerts;

    // AER-1739: which half of the split this section owns. When the equipment
    // is not a diag-split type the predicate is constantly true, so Active
    // Alerts behaves exactly as it did before this ticket.
    const isDiagSplit = this.isDiagSplitType(eqType);
    const belongsToSection = (p: Publish) =>
      !isDiagSplit || (diagOnly ? isDiagAlert(p) : !isDiagAlert(p));

    const isUserOrgReadOnly = userHasRole(6, sState);
    const isUserDezReadOnly = userHasRole(7, sState);
    const isUserReadOnly = isUserOrgReadOnly || isUserDezReadOnly;

    const getSensor = (source: string): any => {
      let sensor = get(sState, 'dash.sensors', []).find(
        (s: Sensor) => s.id === source
      );

      if (!sensor) {
        sensor = { id: source } as any;
      }

      return sensor;
    };

    const columns: ColumnProps<any>[] = [
      {
        dataIndex: 'time',
        title: 'Date',
        width: ispb ? undefined : '120px',
        // tslint:disable-next-line:no-any
        render: (_text: string, msg: Publish) => {
          const time = moment(getTimeForPubAlert(msg, product)).format(
            defaultDateFormat
          );
          return <div css={css(`width: 200px;`)}>{time}</div>;
        },
      },
      {
        dataIndex: 'alert',
        title: 'Alert',
        // tslint:disable-next-line:no-any
        render: (_text: string, msg: Publish) => {
          const equipment = this.state.equipment;
          const rawAccessor = isHandpiece(equipment) ? 'data.alert' : 'data';
          const source: any = get(msg, `${rawAccessor}.source`);
          const sensor = getSensor(source);
          const errorCode: any = get(msg, `${rawAccessor}.error`);
          const equipType = getEqType(equipment);
          return sensor ? (
            <span>{getAlert(sensor.id, errorCode, equipType)}</span>
          ) : null;
        },
      },
      ... !ispb ? [{
        dataIndex: 'message',
        title: 'Message',
        // tslint:disable-next-line:no-any
        render: (_text: string, msg: Publish) => {
          const equipment = this.state.equipment;
          const rawAccessor = isHandpiece(equipment) ? 'data.alert' : 'data';
          const eDef = errorDef(get(msg, `${rawAccessor}.error`, 0));
          const source: any = get(msg, `${rawAccessor}.source`);
          const sensor = getSensor(source);
          const errorCode: any = get(msg, `${rawAccessor}.error`);
          const equipType = getEqType(equipment);
          return (
            <div css={css(SharedStyles.row)}>
              <Icon
                type={'warning'}
                theme={'filled'}
                css={css(`font-size: 16px; color: ${eDef.color}`)}
              />
              <div css={css(SharedStyles.ellipsisText, `margin-left: 10px;`)}>
                {sensor ? getMessage(sensor.id, errorCode, equipType) : null}
              </div>
            </div>
          );
        },
      }] : [],
      ... (!ispb &&
        !isUserReadOnly) ? [{
          dataIndex: 'clear',
          title: 'Clear',
          // tslint:disable-next-line:no-any
          render: (text: string, msg: Publish) => {
            const rawAccessor = isHandpiece(this.state.equipment)
              ? 'data.alert'
              : 'data';
            const eDef = errorDef(get(msg, `${rawAccessor}.error`, 0));
            // AER-1605: only show the X if this *specific* publish is still
            // the active entry for its source — otherwise historic minor
            // alerts (same source, older publish) would all show X icons
            // that pop a modal where Clear Alert is correctly hidden.
            // Shares the publish-active check with the modal.
            const isActive = this.isPublishActiveInMap(msg, alertMap);
            return canClearAlert(eDef, eqType) && isActive ? (
              <Icon
                type={'close-circle'}
                theme={'filled'}
                onClick={() => this.openModal(msg)}
                css={css(`font-size: 16px; color: ${colors.highlight}`)}
              />
            ) : null;
          },
        }] : [],
    ].filter(f => f);

    const showingActive = !showAllMessages;

    // AER-1739: the header reads 'Diagnostic Alerts' per the ticket, and the
    // history view it opens is titled to match so the two takeovers are
    // distinguishable from one another.
    const activeTitle = diagOnly ? 'Diagnostic Alerts' : 'Active Alerts';
    const historyTitle = diagOnly
      ? 'Diagnostic Message History'
      : 'Message History';
    const toggleLabel = `Show ${showAllMessages ? activeTitle : 'Alert History'}`;

    const toggleActive = () => {
      setShowAllMessages(!showAllMessages);
      if (!showAllMessages) {
        this.trackEvent(eventTypes.eq_alert_history);
      }
      // AER-1591: showing/hiding the Alert History view should snap to the
      // top of the screen — entering otherwise inherits the parent scroll
      // position, landing the user mid-page on a fresh subscreen. Reset
      // both the inner ContentContainer and the window — the WebView on
      // mobile scrolls the window itself in some layouts.
      const el = document.getElementById('ContentContainer');
      if (el) el.scrollTop = 0;
      if (typeof window !== 'undefined') window.scrollTo(0, 0);
    };

    const ignore = get(
      getEquipmentModel(e, sState),
      'ignoreAlerts',
      []
    ) as string[];
    // AER-1739: 'Show Alert History' inside Diagnostic Alerts lists diagnostic
    // alerts only, and the Active Alerts history correspondingly drops them —
    // "reuse existing with a different filter" per the ticket.
    const data = (showAllMessages ? alerts : activeAlerts).filter(
      // tslint:disable-next-line:no-any
      (d: any) => {
        const asensor = get(d, 'data.source');
        return ignore.indexOf(asensor) === -1 && belongsToSection(d);
      }
    );
    // AER-1739: Diagnostic Alerts is hidden outright when it has nothing to
    // show — it is an admin-only diagnostic tool and an empty box is clutter
    // (Bruce's call). It deliberately has no empty state of its own; Active
    // Alerts keeps the one it has always had. The history takeover is exempt:
    // once the user is inside it the section has to keep rendering so the link
    // back out stays reachable.
    if (diagOnly && !showAllMessages && (!data || data.length === 0)) {
      return null;
    }
    const showBlank =
      ((!loading && !showAllMessages) || (showAllMessages && !alertsLoading)) &&
      data &&
      data.length === 0;
    // AER-1591: collapse the Active Alerts section by default when there are
    // no active alerts (per Ted's spec). User-driven toggles take precedence.
    const effectiveExpandAlerts = alertsToggled
      ? expandAlerts
      : data && data.length > 0;
    // AER-1739: mobile section collapse, written back to whichever section's
    // copy of the flags this render owns.
    const toggleExpand = () =>
      diagOnly
        ? this.setState({
          expandDiagAlerts: !effectiveExpandAlerts,
          diagAlertsToggled: true,
          showAllDiagMessages: effectiveExpandAlerts
            ? false
            : showAllMessages,
        })
        : this.setState({
          expandAlerts: !effectiveExpandAlerts,
          alertsToggled: true,
          showAllMessages: effectiveExpandAlerts ? false : showAllMessages,
        });
    return ispb ? (
      // AER-1591: Active Alerts mobile redesign — section header w/ underline
      // + chevron, alerts rendered as cards (color-coded triangle on the
      // left per Bruce's spec, not on the right as in Ted's mock), purple
      // close-circle for clearing minor alerts retained.
      <div>
        <div
          onClick={toggleExpand}
          css={css(
            styles.mobileSectionHeader,
            'cursor: pointer; display: flex; align-items: center;'
          )}
        >
          <span>{showingActive ? activeTitle : historyTitle}</span>
          <Icon
            css={css(styles.mobileSectionChevron)}
            type={effectiveExpandAlerts ? 'up' : 'down'}
          />
        </div>

        {effectiveExpandAlerts && (
          <div css={css(styles.overflowHidden)}>
            {!showBlank &&
              data.map((msg: Publish, i: number) => {
                const equipment = this.state.equipment;
                const rawAccessor = isHandpiece(equipment)
                  ? 'data.alert'
                  : 'data';
                const eDef = errorDef(
                  get(msg, `${rawAccessor}.error`, 0)
                );
                const source = get(msg, `${rawAccessor}.source`);
                const sensor = getSensor(source);
                const errorCode = get(msg, `${rawAccessor}.error`);
                const equipType = getEqType(equipment);
                const time = moment(getTimeForPubAlert(msg, product)).format(
                  defaultDateFormat
                );
                // AER-1605: shares the publish-active check with the modal /
                // table column so cleared minor alerts don't show an X icon
                // that pops a modal where Clear Alert is hidden anyway.
                const isActive = this.isPublishActiveInMap(msg, alertMap);
                const showClear =
                  canClearAlert(eDef, eqType) &&
                  isActive &&
                  !isUserReadOnly &&
                  !showAllMessages;

                return (
                  <div
                    key={i}
                    onClick={() => this.openModal(msg)}
                    css={css(styles.mobileAlertCard)}
                  >
                    <Icon
                      type="warning"
                      theme="filled"
                      css={css(styles.mobileAlertCardIcon)}
                      style={{ color: eDef.color }}
                    />
                    <div css={css(styles.mobileAlertCardContent)}>
                      <div css={css(styles.mobileAlertCardTitle)}>
                        {sensor
                          ? getAlert(sensor.id, errorCode, equipType)
                          : null}
                      </div>
                      <div css={css(styles.mobileAlertCardMessage)}>
                        {sensor
                          ? getMessage(sensor.id, errorCode, equipType)
                          : null}
                      </div>
                      <div css={css(styles.mobileAlertCardDate)}>{time}</div>
                    </div>
                    {showClear && (
                      <Icon
                        type="close-circle"
                        theme="filled"
                        onClick={(ev: React.MouseEvent) => {
                          ev.stopPropagation();
                          this.openModal(msg);
                        }}
                        css={css(styles.mobileAlertCardClear)}
                      />
                    )}
                  </div>
                );
              })}

            {showBlank &&
              this.renderBlank(
                showingActive
                  ? 'No active alerts exist.'
                  : 'No messages have been received for this equipment.'
              )}

            <Link css={css(styles.showMore)} onClick={toggleActive}>
              {toggleLabel}
            </Link>
          </div>
        )}

        <div css={css(styles.hrMain)} />
      </div>
    ) : (
      <div>
        <div css={css(styles.overflowHidden)}>
          <div css={css(SharedStyles.row, styles.title)}>
            {showingActive ? activeTitle : historyTitle}
            {!showingActive && (
              <Link
                css={css(styles.showMore, 'margin-left: auto;')}
                onClick={toggleActive}
              >
                {toggleLabel}
              </Link>
            )}
          </div>

          {!showBlank && (
            <TableList
              loading={showAllMessages ? alertsLoading : loading}
              columns={columns}
              data={data as never[]}
              rowClick={this.openModal}
              showPagination={showAllMessages}
              pageSize={50}
              canSelectRows={false}
              implementScroll={false}
            />
          )}

          {showBlank &&
            this.renderBlank(
              showingActive
                ? 'No active alerts exist.'
                : 'No messages have been received for this equipment.'
            )}

          <Link css={css(styles.showMore)} onClick={toggleActive}>
            {toggleLabel}
          </Link>
        </div>

        {!showAllMessages && <div css={css(styles.hrMain)} />}
      </div>
    );
  };
  renderHistory = () => {
    const { sState } = this.props;
    const {
      showAllMessages,
      loading,
      alertsLoading,
      expandAlerts,
    } = this.state;
    const e = this.getEquipment();

    const ispb = isPB(sState);

    const alerts = get(
      sState,
      `dash.equipMap.${e.deviceId}.sensorStatistics`,
      []
    ).filter(
      //@ts-ignore
      f => !get(f, 'data.daily') && get(f, 'event') !== 'dz_sensor_instant'
    );
    const alertMap: any = get(sState, `dash.equipMap.${e.deviceId}.alertMap`, {});

    const activeAlerts = [];
    for (let k in alertMap) {
      let opts = alertMap[k];
      activeAlerts.push(opts);
    }

    // antd v5+ Table needs array dataIndex for nested paths (AER-1465)
    // Explicit ColumnProps<Publish>[] so <TableList<T>> below correctly
    // infers T=Publish; without it react-app-rewired's webpack ts-checker
    // picked T=string from the columns' literal render return types and
    // rejected `data={data as never[]}` at build time even though `yarn
    // tsc` (looser bivariance) accepted it.
    const columns: ColumnProps<Publish>[] = [
      {
        dataIndex: ['data', 'start'],
        title: 'Start',
        // width: ispb ? undefined : '120px',
        // tslint:disable-next-line:no-any
        render: (_text: string, msg: Publish) => {
          const time = moment(getRightTime(_text)).format(defaultDateFormat);
          return time;
        },
      },
      {
        dataIndex: ['data', 'end'],
        title: 'Completion',
        // width: ispb ? undefined : '120px',
        // tslint:disable-next-line:no-any
        render: (_text: string, msg: Publish) => {
          const time = moment(getRightTime(_text)).format(defaultDateFormat);
          return time;
        },
      },
      {
        dataIndex: ['data', 'success'],
        title: 'Status',
        // tslint:disable-next-line:no-any
        render: (_text: string, msg: Publish) => {
          const isSuccess = !!_text;
          return (
            <span style={{ color: isSuccess ? colors.success : colors.error }}>
              {isSuccess ? 'Pass' : 'Fail'}
            </span>
          );
        },
      },
      {
        dataIndex: ['data', 'flags'],
        title: 'Errors',
        // tslint:disable-next-line:no-any
        render: (_text: string, msg: Publish) => {
          return getSterilizerFlagTextFromArray(get(
            msg,
            'data.flags',
            []
          ) as string[]);
        },
      },
      {
        dataIndex: ['data', 'time_target'],
        title: 'Target Time',
        // width: ispb ? undefined : '120px',
        // tslint:disable-next-line:no-any
        render: (_text: string, msg: Publish) => {
          const time = timeText(_text, { includeSeconds: true });
          return time;
        },
      },
      {
        dataIndex: ['data', 'time_elapsed'],
        title: 'Elapsed Time',
        // width: ispb ? undefined : '120px',
        // tslint:disable-next-line:no-any
        render: (_text: string, msg: Publish) => {
          const time = timeText(_text, { includeSeconds: true });
          return time;
        },
      },
      {
        dataIndex: ['data', 'temp_target'],
        title: 'Target Temp',
        // width: ispb ? undefined : '120px',
        // tslint:disable-next-line:no-any
        render: (_text: string, msg: Publish) => {
          return `${_text} F`;
        },
      },
      {
        dataIndex: ['data', 'temp_reached'],
        title: 'Achieved Temp',
        // width: ispb ? undefined : '120px',
        // tslint:disable-next-line:no-any
        render: (_text: string, msg: Publish) => {
          return `${_text} F`;
        },
      },
    ].filter(f => f);

    const showingActive = !showAllMessages;

    const toggleActive = () => {
      this.setState({ showAllMessages: !showAllMessages });
      if (!showAllMessages) {
        this.trackEvent(eventTypes.eq_alert_history);
      }
      // AER-1591: showing/hiding the Alert History view should snap to the
      // top of the screen — entering otherwise inherits the parent scroll
      // position, landing the user mid-page on a fresh subscreen. Reset
      // both the inner ContentContainer and the window — the WebView on
      // mobile scrolls the window itself in some layouts.
      const el = document.getElementById('ContentContainer');
      if (el) el.scrollTop = 0;
      if (typeof window !== 'undefined') window.scrollTo(0, 0);
    };

    const titles = {
      active: 'Sterilization History',
      all: 'Equipment Details',
    };

    const data = showAllMessages ? alerts : take(alerts, 10);
    const showBlank =
      ((!loading && !showAllMessages) || (showAllMessages && !alertsLoading)) &&
      data &&
      data.length === 0;

    return ispb ? (
      <div>
        <div
          onClick={() =>
            this.setState({
              expandAlerts: !expandAlerts,
              showAllMessages: expandAlerts ? false : showAllMessages,
            })
          }
          css={css(SharedStyles.row, styles.expandRow)}
        >
          <div>Sterilization History</div>
          <Icon
            css={css('margin-left: auto;')}
            type={expandAlerts ? 'down' : 'right'}
          />
        </div>

        {expandAlerts && (
          <div css={css(styles.overflowHidden)}>
            <div css={css(SharedStyles.row, styles.title, 'margin-top: 10px;')}>
              {showingActive ? titles.active : titles.all}
              {!showingActive && (
                <Link
                  css={css(styles.showMore, 'margin-left: auto;')}
                  onClick={toggleActive}
                >
                  {`Show ${showAllMessages ? titles.active : titles.all}`}
                </Link>
              )}
            </div>

            {!showBlank && (
              <TableList
                loading={showAllMessages ? alertsLoading : loading}
                columns={columns}
                data={data as never[]}
                showPagination={showAllMessages}
                pageSize={50}
                canSelectRows={false}
                implementScroll={false}
              />
            )}

            {showBlank &&
              this.renderBlank(
                showingActive
                  ? 'No sterilization history exists.'
                  : 'No publishes have been received for this equipment.'
              )}

            <Link css={css(styles.showMore)} onClick={toggleActive}>
              {`Show ${showAllMessages ? titles.all : titles.active}`}
            </Link>
          </div>
        )}

        <div css={css(styles.hrMain)} />
      </div>
    ) : (
      <div>
        <div css={css(styles.overflowHidden)}>
          <div css={css(SharedStyles.row, styles.title)}>
            {titles.active}
            {!showingActive && (
              <Link
                css={css(styles.showMore, 'margin-left: auto;')}
                onClick={toggleActive}
              >
                {`Show ${showAllMessages ? titles.all : titles.active}`}
              </Link>
            )}
          </div>

          {!showBlank && (
            <TableList
              loading={showAllMessages ? alertsLoading : loading}
              columns={columns}
              data={data as never[]}
              showPagination={showAllMessages}
              pageSize={50}
              canSelectRows={false}
              implementScroll={false}
            />
          )}

          {showBlank &&
            this.renderBlank(
              showingActive
                ? `No history exists.`
                : 'No messages have been received for this equipment.'
            )}

          <Link css={css(styles.showMore)} onClick={toggleActive}>
            {`Show ${showAllMessages ? titles.all : titles.active}`}
          </Link>
        </div>
      </div>
    );
  };
  renderServiceReminders = () => {
    const { sState } = this.props;
    const { loading, expandMaint } = this.state;
    const e = this.getEquipment();

    const ispb = isPB(sState);

    const maint = getEquipMaint(e, sState, []);
    // the newest by when it was sent, not the last to arrive
    const latestMaint = (newestFirst(productOf(getEqType(e), e), maint)[0] || {}) as Publish;
    const isGuest = isGuestUser(sState);

    const eqType = getEqType(e);
    if (eqType === ETYPES.sterilizer) {
      return null;
    }

    let serviceReminders: IServiceReminder[] = getTriggeredMaint(
      latestMaint
    ).map(lm => {
      const lastServiced = moment(
        convertDZNowToJSNow(get(lm, 'timeOfReset'))
      ).format(defaultDateFormat);
      const hours = {
        text:
          lm.timeRemaining === 0
            ? '0 hours remaining'
            : lm.timeRemaining < 0
              ? `Service Overdue`
              : `${lm.timeRemaining} hours remaining`,
        color: lm.timeRemaining <= 0 ? colors.error : '',
      };
      return {
        name: lm.text,
        hours,
        lastServiced,
      };
    });

    if (isHandpiece(e)) {
      const [dueForService, hours, lastServiced] = handpieceIsDueForService(
        sState,
        e,
        this.state.serviceHistory
      );
      if (dueForService && hours > 0) {
        let text = '';

        if (hours >= 450 && hours < 500) {
          const remaining = 500 - hours;
          text = `${remaining === 1
            ? '1 hour remaining'
            : `${remaining} hours remaining`
            }`;
        } else if (hours === 500) {
          text = 'Due now';
        } else if (hours > 500) {
          text = `Service Overdue`;
        }

        serviceReminders.push({
          name: 'General Maintenance',
          hours: {
            text,
            color: hours <= 500 ? '' : colors.error,
          },
          lastServiced: lastServiced
            ? lastServiced.format('MMM Do YYYY h:mm a')
            : '',
        });
      }
    }

    serviceReminders.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

    const columns: ColumnProps<IServiceReminder>[] = [
      {
        dataIndex: 'name',
        title: 'Component',
        width: '30%',
      },
      {
        dataIndex: 'hours',
        title: 'Service Due',
        width: '30%',
        render: (text: string, record: IServiceReminder) => {
          return (
            <div
              css={record.hours.color && css(`color: ${record.hours.color};`)}
            >
              {record.hours.text}
            </div>
          );
        },
      },
      {
        dataIndex: 'lastServiced',
        title: 'Last Serviced',
        width: '30%',
      },
      ...!ispb ? [{
        dataIndex: 'action',
        title: ' ',
        width: '10%',
        render: (text: string, record: IServiceReminder) => {
          if (isGuest) { return null }
          return (
            <div css={css(SharedStyles.row)}>
              <Link onClick={() => this.goToServiceRecord(undefined)}>
                <div css={css(SharedStyles.row)}>
                  <_Icon name="plus" size={14} color={colors.highlight} />
                  <div
                    css={css`
                      margin-left: 5px;
                    `}
                  >
                    Add Service Record
                  </div>
                </div>
              </Link>
            </div>
          );
        },
      }] : [],
    ];

    const showBlank =
      !loading && serviceReminders && serviceReminders.length === 0;

    if (isChair(e)) {
      return null;
    }

    // AER-1591: Maintenance Alerts is hidden for Chairs (existing) AND
    // Handpieces on mobile per Ted's spec.
    if (ispb && isHandpiece(e)) {
      return null;
    }

    // AER-1591: collapse Maintenance Alerts by default when there are no
    // reminders (per Ted's spec). User-driven toggles take precedence.
    const effectiveExpandMaint = this.state.maintToggled
      ? expandMaint
      : serviceReminders && serviceReminders.length > 0;
    return ispb ? (
      // AER-1591: Maintenance Alerts mobile redesign — section header with
      // underline + chevron, each reminder rendered as a bordered card with
      // component name (bold), "Last Serviced: <date>" line, then either
      // "Service Overdue" (red) or "X hours remaining". The "+Add Service
      // Record" per-row link is intentionally hidden on mobile per spec.
      <div>
        <div
          onClick={() =>
            this.setState({
              expandMaint: !effectiveExpandMaint,
              maintToggled: true,
            })
          }
          css={css(
            styles.mobileSectionHeader,
            'cursor: pointer; display: flex; align-items: center;'
          )}
        >
          <span>Maintenance Alerts</span>
          <Icon
            css={css(styles.mobileSectionChevron)}
            type={effectiveExpandMaint ? 'up' : 'down'}
          />
        </div>
        {effectiveExpandMaint && (
          <div css={css(styles.overflowHidden)}>
            {!showBlank &&
              serviceReminders.map((sr, i) => (
                <div
                  key={i}
                  css={css(styles.mobileAlertCard, 'cursor: default;')}
                >
                  <div css={css(styles.mobileAlertCardContent)}>
                    <div css={css(styles.mobileAlertCardTitle)}>{sr.name}</div>
                    <div css={css(styles.mobileMaintRow)}>
                      <span css={css(styles.mobileMaintLabel)}>
                        Last Serviced:{' '}
                      </span>
                      <span css={css(styles.mobileMaintValue)}>
                        {sr.lastServiced || '—'}
                      </span>
                    </div>
                    <div
                      css={css(
                        styles.mobileMaintRow,
                        sr.hours.color && `color: ${sr.hours.color};`
                      )}
                    >
                      {sr.hours.text}
                    </div>
                  </div>
                </div>
              ))}

            {showBlank &&
              this.renderBlank(
                'No maintenance alerts have been received for this equipment.'
              )}
          </div>
        )}
        <div css={css(styles.hrMain)} />
      </div>
    ) : (
      <div>
        <div css={css(styles.overflowHidden)}>
          <div css={css(SharedStyles.row)}>
            <div css={css(styles.title)}>Maintenance Alert</div>
          </div>

          {!showBlank && (
            <TableList
              loading={loading}
              columns={columns}
              data={serviceReminders as never[]}
              showPagination={false}
              canSelectRows={false}
              implementScroll={false}
            />
          )}

          {showBlank &&
            this.renderBlank(
              'No maintenance alerts have been received for this equipment.'
            )}
        </div>
        <div css={css(styles.hrMain)} />
      </div>
    );
  };
  renderServiceRecords = () => {
    const {
      serviceHistory,
      showAllHistory,
      loading,
      expandService,
    } = this.state;
    const { sState } = this.props;
    const e = this.getEquipment();

    const ispb = isPB(sState);
    const eissmart = isSmartChair(e);
    const isGuest = isGuestUser(sState);

    const eqType = getEqType(e);
    if (eqType === ETYPES.sterilizer || eissmart) {
      return null;
    }

    const limit = 10;

    const width = get(
      document.getElementById('ServiceRecordContainer'),
      'offsetWidth',
      1000
    );

    const columns: ColumnProps<Service>[] = [
      {
        dataIndex: 'serviceDate',
        title: 'Date',
        width: '180px',
        render: (text: string) => {
          return <div>{moment(text || undefined).format('MMM Do YYYY')}</div>;
        },
      },
      ... !ispb ? [{
        dataIndex: 'techName',
        title: 'Serviced By',
        width: '180px',
        render: (text: string) => {
          return <div>{text || 'N/A'}</div>;
        },
      }] : [],
      ... !ispb ? [{
        dataIndex: 'taskSummary',
        title: 'Components',
        render: (text: string, record: Service) => {
          const services = (get(record, 'services', []) as ServiceSerial[])
            .filter(getServiceType)
            .map(s => get(getServiceType(s), 'name'));

          const _css = `
            display: block;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: ${width - 460}px;
          `;
          return (
            <div css={css(SharedStyles.row, _css)}>
              {services.length > 0 ? services.join(', ') : 'None'}
            </div>
          );
        },
      }] : [],
      {
        dataIndex: 'services',
        title: 'Services',
        width: '60px',
        render: (text: string, record: Service) => {
          const services = (get(record, 'services', []) as ServiceSerial[])
            .filter(getServiceType)
          return <div>{`${(size(services)) || '-'}`}</div>;
        },
      },
    ];

    const showBlank = !loading && serviceHistory && serviceHistory.length === 0;

    const data = (showAllHistory
      ? serviceHistory
      : take(serviceHistory, limit)) as never[];

    // AER-1591: collapse Service Records by default when there are no
    // records (per Ted's spec). User-driven toggles take precedence.
    const effectiveExpandService = this.state.serviceToggled
      ? expandService
      : serviceHistory && serviceHistory.length > 0;
    return ispb ? (
      // AER-1591: Service Records mobile redesign — section header w/
      // purple plus button + chevron, simplified two-column Date/Services
      // table with alternating row backgrounds. Drops the count from the
      // header, hides Serviced By + Components per spec (already done above
      // via !ispb in `columns`).
      <div id={'ServiceRecordContainer'}>
        <div
          onClick={() =>
            this.setState({
              expandService: !effectiveExpandService,
              serviceToggled: true,
              showAllHistory: effectiveExpandService ? false : showAllHistory,
            })
          }
          css={css(
            styles.mobileSectionHeader,
            'cursor: pointer; display: flex; align-items: center;'
          )}
        >
          <span>Service Records</span>
          {!isGuest && (
            <Icon
              type="plus-circle"
              theme="filled"
              onClick={(ev: React.MouseEvent) => {
                ev.stopPropagation();
                this.goToServiceRecord(undefined);
              }}
              css={css(styles.mobileServicePlusBtn)}
            />
          )}
          <Icon
            css={css(
              styles.mobileSectionChevron,
              !isGuest && 'margin-left: 0;'
            )}
            type={effectiveExpandService ? 'up' : 'down'}
          />
        </div>

        {effectiveExpandService && (
          <div css={css(styles.overflowHidden)}>
            {!showBlank && (
              <div css={css(styles.mobileServiceTable)}>
                <div css={css(styles.mobileServiceHeaderRow)}>
                  <div
                    css={css(
                      styles.mobileServiceHeaderCell,
                      styles.mobileServiceCellDate
                    )}
                  >
                    Date
                  </div>
                  <div css={css(styles.mobileServiceHeaderCell)}>Services</div>
                </div>
                {data.map((record: Service, i: number) => {
                  const services = (
                    get(record, 'services', []) as ServiceSerial[]
                  ).filter(getServiceType);
                  const dateStr = moment(
                    record.serviceDate || undefined
                  ).format('MM/DD/YY');
                  return (
                    <div
                      key={i}
                      onClick={() => this.goToServiceRecord(record, false)}
                      css={css(
                        styles.mobileServiceRow,
                        i % 2 === 0 && styles.mobileServiceRowAlt
                      )}
                    >
                      <div
                        css={css(
                          styles.mobileServiceCell,
                          styles.mobileServiceCellDate
                        )}
                      >
                        {dateStr}
                      </div>
                      <div css={css(styles.mobileServiceCell)}>
                        {size(services) || '-'}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {showBlank &&
              this.renderBlank(
                'No service records have been entered for this equipment.'
              )}

            {serviceHistory && serviceHistory.length > limit && (
              <Link
                css={css(styles.showMore)}
                onClick={() =>
                  this.setState({ showAllHistory: !showAllHistory })
                }
              >
                {`Show ${showAllHistory ? 'Less' : 'More'}`}
              </Link>
            )}
          </div>
        )}
        <div css={css(styles.hrMain)} />
      </div>
    ) : (
      <div id={'ServiceRecordContainer'}>
        <div css={css(styles.overflowHidden)}>
          <div css={css(SharedStyles.row)}>
            <div css={css(styles.title)}>Service Records</div>
            {!isGuest && <Link
              onClick={() => this.goToServiceRecord(undefined)}
              css={css(SharedStyles.row, styles.rightLink)}
            >
              <_Icon name="plus" css={css(`margin-right: 5px`)} />
              <span>Add Service Record</span>
            </Link>}
          </div>

          {!showBlank && (
            <TableList
              loading={loading}
              columns={columns}
              data={data}
              showPagination={false}
              canSelectRows={false}
              implementScroll={false}
              rowClick={row => this.goToServiceRecord(row, false)}
            />
          )}

          {showBlank &&
            this.renderBlank(
              'No service records have been entered for this equipment.'
            )}

          {serviceHistory && serviceHistory.length > limit && (
            <Link
              css={css(styles.showMore)}
              onClick={() => this.setState({ showAllHistory: !showAllHistory })}
            >
              {`Show ${showAllHistory ? 'Less' : 'More'}`}
            </Link>
          )}
        </div>
      </div>
    );
  };
  onEditClick = () => {
    const { equipment } = this.state;
    this.props.history.push('/dashboard/editEquipment', {
      equipment,
    });
  };
  goToServiceRecord = (serviceRecord: Service | undefined, editMode = true) => {
    const { model, equipment } = this.state;
    const [due] = handpieceIsDueForService(
      this.props.sState,
      equipment,
      this.state.serviceHistory
    );

    this.props.history.push('/dashboard/manageServiceRecord', {
      equipment: this.getEquipment(),
      model,
      serviceRecord,
      editMode,
      serviceTypes: due ? [serviceType.hp_general] : [],
    });
  };
  goToBillingHistory = (_equipmentId: string) => {
    let { model, latestEquipmentPublishData, equipment } = this.state;
    let config = latestEquipmentPublishData
      ? latestEquipmentPublishData.dz_config
      : undefined;
    const appState = this.props.sState;

    if (!equipment) {
      equipment = this.getEquipment();
    }

    if (!config) {
      config = getEquipConfig(equipment, appState) as any;
    }

    this.props.history.push('/dashboard/billingHistory', {
      equipment: this.getEquipment(),
      model,
      config,
    });
  };
  renderHandpieceDeviceStatusAlerts = () => {
    const { sState } = this.props;
    const e = this.getEquipment();
    const ispb = isPB(sState);
    const isHpDebugModeOn = getDebugStatusHandpiece(sState, e.deviceId);

    const display = [
      {
        state: userHasRole([0], sState) && isHpDebugModeOn,
        title: 'Debug Mode On',
        color: colors.error,
      },
    ].filter(i => i.state);

    return display.length === 0 ? null : (
      <div
        css={css(
          // AER-1591: on mobile the status banner ("Power Up Override",
          // "OFFLINE", etc.) extends edge-to-edge of the screen — same
          // full-bleed pattern as desktop.
          ispb
            ? styles.deviceStatusAlertContainer + 'margin-bottom: 10px;'
            : styles.deviceStatusAlertContainer
        )}
      >
        {display.map(d => (
          <div
            key={d.title}
            css={css(styles.deviceStatusAlert, `background-color: ${d.color}`)}
          >
            {d.title}
          </div>
        ))}
      </div>
    );
  };
  startReconnect = () => {
    const e = this.getEquipment();
    sendNativeEvent({ action: 'router', data: `/setupwifi?${e.deviceId}` })
  }
  renderDeviceStatusAlerts = () => {
    const { sState } = this.props;
    const e = this.getEquipment();
    const dState = getDeviceStatusFromEquip(e);
    const ispb = isPB(sState);
    const isMsom = isMuon(e);

    const display = [
      {
        state: dState.isAlwaysOn
          ? false
          : dState.off,
        title: 'OFFLINE',
        color: colors.statusOff,
        render: () => {
          if (!isMsom) { return null }

          return (
            <Row style={{ position: 'absolute', right: 10 }}>
              <Button title="Reconnect wifi" size="small" outline onClick={this.startReconnect} />
            </Row>
          )
        }
      },
      {
        state: dState.highVoltage,
        title: 'Power Up Override',
        color: colors.statusStandby,
      },
      {
        state: !dState.scheduleEnabled && !isChair(e),
        title: 'Equipment Schedule Disabled',
        color: colors.statusOff,
      },
      {
        state: userHasRole([0], sState) && dState.debug,
        title: 'Debug Mode On',
        color: colors.error,
      },
      {
        state: userHasRole([0], sState) && !get(e, 'showOnDash'),
        title: 'ShowOnDash Set to FALSE',
        color: colors.error,
      },
      {
        state: dState.highPressure,
        title: 'High Pressure Mode On',
        color: colors.statusStandby,
      },
      {
        state: dState.highAltitude,
        title: 'High Altitude Mode On',
        color: colors.statusStandby,
      },
      {
        state: dState.maint,
        title: 'Maintenance Mode On',
        color: colors.error,
      },
    ].filter(f => f.state);

    return (
      <div
        css={css(
          // AER-1591: full-bleed status banner on mobile (same as desktop).
          ispb
            ? styles.deviceStatusAlertContainer + 'margin-bottom: 10px;'
            : (display.length == 0 ? '' : styles.deviceStatusAlertContainer)
        )}
      >
        {display.map(d => (
          <div
            key={d.title}
            css={css(styles.deviceStatusAlert, `background-color: ${d.color}`)}
          >
            {d.title}
            {/* @ts-ignore */}
            {d.render ? d.render() : null}
          </div>
        ))}
      </div>
    );
  };
  renderBadAccessAlert = () => {
    this.props.app.modal.warning({
      title: 'Functionality Not Available',
      content:
        //tslint:disable-next-line: max-line-length
        'Your user account does not have access to complete this functionality.\
        If you feel that this is incorrect, please contact your company Admin.',
      onOk: () => {
        return 0;
      },
    });
  };
  goToViewTGroup = () => {
    const { tandemGroup, model } = this.state;
    tandemGroup &&
      this.props.history.push('/dashboard/viewTandemGroup', {
        equipment: this.state.equipment,
        model,
        tandemGroup,
        showSideBar: true,
        back: `< Back to Equipment Details`,
      });
  };

  goToAddTGroup = () => {
    if (userHasRole(6, this.props.sState)) {
      this.renderBadAccessAlert();
      return;
    }
    const equipment = this.getEquipment();
    const config = getEquipConfig(equipment, this.props.sState);
    const fwVersion: number = get(config, 'fw_version');
    if (fwVersion < 34) {
      return this.props.app.modal.error(getFWErrorProps(
        equipment.equipmentSN as string,
        fwVersion.toString()
      ));
    }
    const { model } = this.state;
    this.props.history.push('/dashboard/addTandemGroup', {
      equipment: this.state.equipment,
      locationId: this.state.equipment.locationId,
      orgId: this.state.equipment.dentalOrgId,
      model,
      tandemGroup: undefined,
      editMode: false,
      isAdd: true,
      showSideBar: true,
      back: `< Back to Equipment Details`,
    });
  };

  onAddEquipToTG = async (selectedTG: SelectValue) => {
    const { availableTGroups } = this.state;
    const equipment = this.getEquipment();
    const _availableTGroups = (availableTGroups as unknown) as TandemGroup[];
    const tandemGroup = _availableTGroups.find(
      (tg: TandemGroup) => tg.id === selectedTG
    ) as TandemGroup;

    try {
      const arg = generateTGDeviceCMD(tandemGroup.groupNumber, TG_ROLES.PEER);
      await sendDeviceCommand(
        get(equipment, 'deviceId', ''),
        { arg },
        {
          tandem: {
            tandemGroupNumber: get(tandemGroup, 'groupNumber'),
            tandemGroupRole: TG_ROLES.PEER,
          },
        }
      );
      await this.retrieveEquipment();
      message.success(`${equipment.equipmentSN
        } successfully added to tandem group${get(tandemGroup, 'name')}`);
    } catch (error) {
      message.error('There was a problem adding the Equipment to the Tandem Group');
      console.warn(error);
    }
    return true;
  };
  toggleModal = () => {
    const equipment = this.getEquipment();
    const config = getEquipConfig(equipment, this.props.sState);
    const fwVersion: number = get(config, 'fw_version');
    if (fwVersion < 34) {
      return this.props.app.modal.error(getFWErrorProps(
        equipment.equipmentSN as string,
        fwVersion.toString()
      ));
    }
    this.setState({
      addEquipToTGModalVisible: !this.state.addEquipToTGModalVisible,
    });
  };
  renderWifiConnection = (e: EquipmentRecord) => {
    const isMsom = isMuon(e);

    if (!isMsom) { return null }

    const { isConnected, connectedToWifi } = getMuonConnection(e);

    return (
      <Row style={{ marginLeft: 'auto' }}>
        <Column>
          <div>
            connected: {isConnected ? 'connected' : 'not connected'}
          </div>
          <div>
            connection: {connectedToWifi ? 'wifi' : 'cell'}
          </div>
        </Column>
      </Row>
    )
  }

  render() {
    const { sState } = this.props;
    const {
      loading,
      loadingSensor,
      serviceOrg,
      dentalOrg,
      model,
      modalVisible,
      selectedPublish,
      sendingCommand,
      showAllMessages,
      showAllDiagMessages,
      modalChart,
      showAllHistory,
      tandemGroup,
      addEquipToTGModalVisible,
      availableTGroups,
      equipment,
      latestEquipmentPublishData,
    } = this.state;
    const e = this.getEquipment();
    //tslint:disable-next-line:no-any
    const chosenSensor = get(modalChart, 'chosenSensor') as any;
    const eMap = get(sState, `dash.equipMap.${e.deviceId}`);
    const config: any = getEquipConfig(e, sState);
    const alertMap = getRelevantAlertMap(keyBy(this.activeAlerts, 'data.source'));
    const alerts = get(eMap, 'alerts', []);
    // AER-1605: shares the publish-active check with the Clear column X
    // buttons in the Alert History table / mobile cards — keeps modal
    // Clear button and X icons in sync (Danielle's feedback was that they
    // had drifted: "X buttons are now out of sync with the actual option
    // to Clear Alert that is presented in the modals... it should share
    // logic with the modal button").
    const selPubIsActive = this.isPublishActiveInMap(selectedPublish, alertMap);

    const ispb = isPB(sState);

    const eqType = getEqType(equipment);

    // AER-1591: Dental Org users on mobile see a simplified Performance
    // section. Allow-list of column labels per equipment type:
    //   - all types: "Signal Strength"
    //   - vacs / compressors: "Equipment Runtime"
    //   - handpieces: "Runtime", "Current Preset"
    //   - chairs: "Patient In Chair"
    // Additional info rows (renderInfoRowEx) are dropped entirely for DO
    // mobile so only the Performance row is visible.
    const isDOMobile =
      ispb && (isDentalOrgUser(sState) || isDentalOrgAdmin(sState));
    let restrictColumnTexts: string[] | undefined;
    if (isDOMobile) {
      restrictColumnTexts = ['Signal Strength'];
      if (eqType === ETYPES.handpiece) {
        restrictColumnTexts.push('Runtime', 'Current Preset');
      } else if (eqType === ETYPES.chair) {
        restrictColumnTexts.push('Patient In Chair');
      } else {
        // vac / compressor / sterilizer / etc.
        restrictColumnTexts.push('Equipment Runtime');
      }
    }

    const sensorInfo = this.getSensorInfo();
    const infoRows = generateInfoRows(e, {
      model,
      sState,
      loading: loadingSensor,
      click: this.clickCol,
      pubData: latestEquipmentPublishData,
      sensorInfo,
      alertMap,
      config,
      restrictColumnTexts,
    });

    const infoRest = isDOMobile
      ? []
      : infoRows
        ? (infoRows || []).slice(1)
        : [];

    const freshConfig = getEquipConfig(equipment, sState);

    const hideStatus = [ETYPES.sterilizer].indexOf(eqType) > -1;

    return (
      <div css={css(styles.container, ispb && 'margin-bottom: 20px;')}>
        <Global styles={global} />
        {ispb && this.renderDeviceStatusAlerts()}
        {/* {ispb && isHp && this.renderHandpieceDeviceStatusAlerts()} */}

        <div
          css={css(
            SharedStyles.row,
            `width: 100%;`,
            // AER-1591: enlarge the mobile Back tap target and vertically
            // center it between the top of the screen / banners (above) and
            // the Get Latest Data button (below) so it isn't crowded.
            ispb && `padding: 8px 0; margin-bottom: 4px;`
          )}
        >
          <Link
            onClick={this.goBack}
            css={css(ispb && `font-size: 16px; padding: 4px 0;`)}
          >
            {'< Back'}
          </Link>
        </div>

        <div
          css={css(
            styles.container,
            !ispb && `flex-direction: row;`,
            ispb && 'margin-bottom: 0px;'
          )}
        >
          {!ispb && (
            <Sidebar
              equipment={e}
              showBadAccess={this.renderBadAccessAlert}
              serviceOrg={serviceOrg}
              dentalOrg={dentalOrg}
              model={model}
              onEditClick={this.onEditClick}
              // @ts-ignore: freshConfig is loosely typed
              config={freshConfig}
              showReplace={!userHasRole(7, sState)}
              waitForNewConfig={this.props.waitForNewConfig}
              updateEquipment={() => this.retrieveEquipment()}
              tandemGroup={tandemGroup}
              tandemGroups={availableTGroups}
              showTandemGroup
              goToViewTGroup={this.goToViewTGroup}
              goToAddTGroup={this.goToAddTGroup}
              toggleModal={this.toggleModal}
              goToAddUser={this.goToAddUser}
              goToBillingHistory={this.goToBillingHistory}
            />
          )}

          {/* AER-1591: mobile actions row — sits above the top card per
              Ted's mock. [Get Latest Data] on the left, [Online status +
              toggle] on the right. */}
          {ispb && (
            <div css={css(styles.mobileActionsRow)}>
              {!this.isAlertHistoryOpen() && !isSmartChair(e) && (
                <Button
                  css={css('flex-shrink: 0;')}
                  title="Get Latest Data"
                  loading={loadingSensor}
                  onClick={() => this.retrieveLatestSensor(true)}
                />
              )}
              {!hideStatus && (
                <div css={css(styles.mobileStatusGroup)}>
                  <span css={css(styles.mobileStatusText)}>
                    {this.getDeviceStatusText(e)}
                    {sendingCommand && (
                      <Icon css={css('margin-left: 4px;')} type="loading" />
                    )}
                  </span>
                  {this.renderStatusSwitch(e, eqType)}
                </div>
              )}
            </div>
          )}

          {/* AER-1591: mobile redesign — replace the standalone hero image
              with a unified top card showing the model image + equipment SN +
              Model + Install Date + Service Due. The previously-shown
              FormTitle equipment-name is also hidden on mobile because the
              SN line in the card serves the same identity role. */}
          {ispb && (() => {
            const sortedMaint = sortBy(
              get(equipment, 'status.maint', []) as MaintStatus[],
              'timeDiff'
            );
            const isServiceOverDueMobile = !!sortedMaint.find(
              (m: MaintStatus) => m.timeDiff <= 0
            );
            const isServiceDueMobile = !!sortedMaint.find(
              (m: MaintStatus) => m.timeDiff > 0
            );
            const timeUntilServiceDueMobile = get(last(sortedMaint), 'timeDiff');
            const installDateRaw = e.installDate;
            const showInstallDate =
              !!installDateRaw && installDateRaw !== 'null';
            const modelLabel = get(model, 'displayName', '') || get(model, 'name', '');
            const snLabel = e.equipmentSN || e.name || '';
            return (
              <div css={css(styles.mobileTopCard)}>
                {/* AER-1589: pass `config` so chairs with `chair_mount=true`
                    pick up the with-mount image (`images.chairMount0`)
                    instead of the default `image`. Mirrors what the
                    desktop sidebar does (sidebar.component.tsx line ~882);
                    omitting it here was the reason QA saw the no-mount
                    chair render on mobile while the desktop view rendered
                    correctly for the same equipment record. */}
                <ModelImage
                  css={css(styles.mobileTopCardImage)}
                  model={model}
                  config={config}
                />
                <div css={css(styles.mobileTopCardInfo)}>
                  <div css={css(styles.mobileTopCardSN)}>
                    {snLabel}
                    {loading && (
                      <Icon
                        css={css('margin-left: 8px;')}
                        type={'loading'}
                      />
                    )}
                  </div>
                  {!!modelLabel && (
                    <p css={css(styles.mobileTopCardRow)}>
                      <span css={css(styles.mobileTopCardLabel)}>
                        Model:{' '}
                      </span>
                      <span css={css(styles.mobileTopCardValue)}>
                        {modelLabel}
                      </span>
                    </p>
                  )}
                  {showInstallDate && (
                    <p css={css(styles.mobileTopCardRow)}>
                      <span css={css(styles.mobileTopCardLabel)}>
                        Install Date:{' '}
                      </span>
                      <span css={css(styles.mobileTopCardValue)}>
                        {moment(installDateRaw as string).format('L')}
                      </span>
                    </p>
                  )}
                  {isServiceOverDueMobile ? (
                    <p
                      css={css(
                        styles.mobileTopCardRow,
                        styles.mobileTopCardOverdue
                      )}
                    >
                      Service Overdue
                    </p>
                  ) : isServiceDueMobile &&
                    (timeUntilServiceDueMobile || 0) > 0 ? (
                    <p css={css(styles.mobileTopCardRow)}>
                      <span css={css(styles.mobileTopCardLabel)}>
                        Service Due:{' '}
                      </span>
                      <span css={css(styles.mobileTopCardValue)}>
                        {`${timeUntilServiceDueMobile} Hours`}
                      </span>
                    </p>
                  ) : null}
                </div>
              </div>
            );
          })()}

          <div css={css(ispb ? styles.mainContainerPB : styles.mainContainer)}>
            {!ispb && this.renderDeviceStatusAlerts()}
            {/* {!ispb && isHp && this.renderHandpieceDeviceStatusAlerts()} */}

            {/* AER-1591: on mobile the FormTitle name is hidden (SN line in
                the top card serves the same role) and the status switch was
                moved to the new actions row above the card. So this whole
                row only renders on desktop. */}
            {!ispb && (
              <div css={css(SharedStyles.row)}>
                <FormTitle size={'16px'}>
                  <div css={css(SharedStyles.row)}>
                    {e.name || get(model, 'name', '')}
                    {loading && (
                      <Icon
                        css={css`
                          margin-left: 10px;
                        `}
                        type={'loading'}
                      />
                    )}
                  </div>
                </FormTitle>

                {!hideStatus && (
                  <div
                    css={css(
                      SharedStyles.row,
                      `margin-left: auto;`
                    )}
                  >
                    <span
                      css={css`
                        font-size: 16px;
                        margin-right: 5px;
                      `}
                    >
                      {this.getDeviceStatusText(e)}
                      {sendingCommand && (
                        <Icon css={css('margin-left: 4px;')} type="loading" />
                      )}
                    </span>

                    {this.renderStatusSwitch(e, eqType)}
                  </div>
                )}
              </div>
            )}

            {this.renderSubTitle()}

            {!this.isAlertHistoryOpen() && !showAllHistory && infoRows && (
              <div>
                {this.renderInfoRow1(get(infoRows, 0))}

                {infoRest.map((ir, i) =>
                  this.renderInfoRowEx(ir, {
                    equipment,
                    sensorInfo,
                    includeLink: i === 0,
                  })
                )}

                {<div css={css(styles.hrMain)} />}
              </div>
            )}

            {/* AER-1591: Profile Usage is hidden on mobile (handpieces only). */}
            {!showAllHistory &&
              !this.isAlertHistoryOpen() &&
              !ispb &&
              isHandpiece(e) &&
              this.renderPerProfileUsage()}

            {!showAllHistory &&
              !showAllDiagMessages &&
              this.renderMessages()}

            {/* AER-1739: Diagnostic Alerts sits directly below Active Alerts
                and above Service Reminders (Bruce's call). Each section hides
                while the other's Alert History takeover is open, and this one
                renders nothing at all unless the viewer is DentalEZ Admin /
                Tech looking at utility equipment that actually has diagnostic
                alerts. */}
            {!showAllHistory &&
              !showAllMessages &&
              this.renderMessages(true)}

            {!this.isAlertHistoryOpen() &&
              !showAllHistory &&
              this.renderServiceReminders()}

            {!this.isAlertHistoryOpen() && this.renderServiceRecords()}

            {/* AER-1591: on mobile, Dental Org users get a Service-Provider-
                only sidebar — they shouldn't see Edit Details / Debug Mode /
                Show in Web App etc., but the Service Provider section IS
                meaningful and goes below Service Records. Non-DO users get
                the full sidebar (Service Provider + Technical Controls +
                misc params). */}
            {ispb && !showAllHistory && !this.isAlertHistoryOpen() && (
              // @ts-ignore: sState/history are injected by connect/withRouter
              <Sidebar
                equipment={e}
                serviceOrg={serviceOrg}
                dentalOrg={dentalOrg}
                model={model}
                onEditClick={this.onEditClick}
                config={config}
                waitForNewConfig={this.props.waitForNewConfig}
                updateEquipment={() => this.retrieveEquipment()}
                isPhoneBreak={ispb}
                goToBillingHistory={this.goToBillingHistory}
                serviceProviderOnly={
                  isDentalOrgUser(sState) || isDentalOrgAdmin(sState)
                }
              />
            )}
          </div>
        </div>

        <ModalEvent
          visible={modalVisible}
          allowClear={userHasRole([6, 7], sState) === false}
          equipment={e}
          publish={selectedPublish}
          isActive={selPubIsActive}
          onClear={() => {
            this.setState({ modalVisible: false });
            this.retrieveEquipment();
          }}
          onClose={() => this.setState({ modalVisible: false })}
        />

        {/* @ts-ignore: sState/addToMap injected by connect */}
        <ModalChart
          loading={loading}
          latestSensorInfo={
            chosenSensor ? get(sensorInfo, `${chosenSensor}`) : null
          }
          deviceId={get(e, 'deviceId', '')}
          equipment={e}
          onClose={() => this.setState({ modalChart: undefined })}
          alerts={alerts}
          {...modalChart}
        />
        <AddEquipToTGModal
          visible={addEquipToTGModalVisible}
          onAddEquipToTG={this.onAddEquipToTG}
          availableTGroups={(availableTGroups as unknown) as TandemGroup[]}
          toggleModal={this.toggleModal}
        />
      </div>
    );
  }
}

export const EquipmentDetailsComponent = WithAppConfig(withRouter(_EquipmentDetailsComponent));
